export function SearchIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9999 20.9999L16.6499 16.6499"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function NotifyClientIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.8497 9.825C3.63304 9.825 3.45387 9.75 3.3122 9.6C3.17054 9.45 3.10804 9.275 3.1247 9.075C3.20804 7.99167 3.47887 6.9625 3.9372 5.9875C4.39554 5.0125 5.01637 4.15 5.7997 3.4C5.9497 3.26667 6.13304 3.20417 6.3497 3.2125C6.56637 3.22083 6.7497 3.30833 6.8997 3.475C7.03304 3.625 7.09554 3.8 7.0872 4C7.07887 4.2 6.9997 4.375 6.8497 4.525C6.21637 5.14167 5.7122 5.8375 5.3372 6.6125C4.9622 7.3875 4.73304 8.20833 4.6497 9.075C4.61637 9.29167 4.5247 9.47083 4.3747 9.6125C4.2247 9.75417 4.0497 9.825 3.8497 9.825ZM20.1747 9.825C19.9747 9.825 19.8039 9.75417 19.6622 9.6125C19.5205 9.47083 19.433 9.29167 19.3997 9.075C19.3164 8.20833 19.0914 7.3875 18.7247 6.6125C18.358 5.8375 17.8664 5.14167 17.2497 4.525C17.0997 4.375 17.0205 4.2 17.0122 4C17.0039 3.8 17.0664 3.625 17.1997 3.475C17.3497 3.30833 17.5289 3.22083 17.7372 3.2125C17.9455 3.20417 18.1247 3.275 18.2747 3.425C19.0414 4.19167 19.6497 5.05417 20.0997 6.0125C20.5497 6.97083 20.8164 7.99167 20.8997 9.075C20.9164 9.275 20.8539 9.45 20.7122 9.6C20.5705 9.75 20.3914 9.825 20.1747 9.825ZM4.7497 19C4.53304 19 4.35387 18.9292 4.2122 18.7875C4.07054 18.6458 3.9997 18.4667 3.9997 18.25C3.9997 18.0333 4.07054 17.8542 4.2122 17.7125C4.35387 17.5708 4.53304 17.5 4.7497 17.5H6.0997V9.85C6.0997 8.48333 6.5122 7.24583 7.3372 6.1375C8.1622 5.02917 9.2497 4.33333 10.5997 4.05V3.325C10.5997 2.94167 10.7372 2.625 11.0122 2.375C11.2872 2.125 11.6164 2 11.9997 2C12.383 2 12.7122 2.125 12.9872 2.375C13.2622 2.625 13.3997 2.94167 13.3997 3.325V4.05C14.7497 4.33333 15.8414 5.02917 16.6747 6.1375C17.508 7.24583 17.9247 8.48333 17.9247 9.85V17.5H19.2497C19.4664 17.5 19.6455 17.5708 19.7872 17.7125C19.9289 17.8542 19.9997 18.0333 19.9997 18.25C19.9997 18.4667 19.9289 18.6458 19.7872 18.7875C19.6455 18.9292 19.4664 19 19.2497 19H4.7497ZM11.9997 22C11.4664 22 10.9997 21.8042 10.5997 21.4125C10.1997 21.0208 9.9997 20.55 9.9997 20H13.9997C13.9997 20.55 13.8039 21.0208 13.4122 21.4125C13.0205 21.8042 12.5497 22 11.9997 22ZM7.5997 17.5H16.4247V9.85C16.4247 8.6 15.9997 7.54583 15.1497 6.6875C14.2997 5.82917 13.258 5.4 12.0247 5.4C10.7747 5.4 9.7247 5.82917 8.8747 6.6875C8.0247 7.54583 7.5997 8.6 7.5997 9.85V17.5Z"
        fill={color}
      />
    </svg>
  );
}
export function DashboardIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.3125 12.25C10.4871 12.25 12.25 10.4871 12.25 8.3125C12.25 6.13788 10.4871 4.375 8.3125 4.375C6.13788 4.375 4.375 6.13788 4.375 8.3125C4.375 10.4871 6.13788 12.25 8.3125 12.25Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6875 12.25C21.8621 12.25 23.625 10.4871 23.625 8.3125C23.625 6.13788 21.8621 4.375 19.6875 4.375C17.5129 4.375 15.75 6.13788 15.75 8.3125C15.75 10.4871 17.5129 12.25 19.6875 12.25Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3125 23.625C10.4871 23.625 12.25 21.8621 12.25 19.6875C12.25 17.5129 10.4871 15.75 8.3125 15.75C6.13788 15.75 4.375 17.5129 4.375 19.6875C4.375 21.8621 6.13788 23.625 8.3125 23.625Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6875 23.625C21.8621 23.625 23.625 21.8621 23.625 19.6875C23.625 17.5129 21.8621 15.75 19.6875 15.75C17.5129 15.75 15.75 17.5129 15.75 19.6875C15.75 21.8621 17.5129 23.625 19.6875 23.625Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CalendarIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.75 4.375H5.25C4.76675 4.375 4.375 4.76675 4.375 5.25V22.75C4.375 23.2332 4.76675 23.625 5.25 23.625H22.75C23.2332 23.625 23.625 23.2332 23.625 22.75V5.25C23.625 4.76675 23.2332 4.375 22.75 4.375Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 2.625V6.125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 2.625V6.125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.375 9.625H23.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BuildingsIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 23.625H26.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 23.625V4.375C15.75 4.14294 15.6578 3.92038 15.4937 3.75628C15.3296 3.59219 15.1071 3.5 14.875 3.5H4.375C4.14294 3.5 3.92038 3.59219 3.75628 3.75628C3.59219 3.92038 3.5 4.14294 3.5 4.375V23.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5 23.625V11.375C24.5 11.1429 24.4078 10.9204 24.2437 10.7563C24.0796 10.5922 23.8571 10.5 23.625 10.5H15.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7.875H10.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 14.875H12.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 19.25H10.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 19.25H21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 14.875H21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UsersIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.625 17.5C12.7661 17.5 15.3125 14.9536 15.3125 11.8125C15.3125 8.67138 12.7661 6.125 9.625 6.125C6.48388 6.125 3.9375 8.67138 3.9375 11.8125C3.9375 14.9536 6.48388 17.5 9.625 17.5Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.9966 6.33281C17.4994 6.19645 18.0178 6.12659 18.5388 6.125C20.0472 6.125 21.4938 6.72422 22.5604 7.79083C23.6271 8.85744 24.2263 10.3041 24.2263 11.8125C24.2263 13.3209 23.6271 14.7676 22.5604 15.8342C21.4938 16.9008 20.0472 17.5 18.5388 17.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 21.591C2.63807 20.3273 3.81723 19.2958 5.18788 18.5838C6.55854 17.8717 8.08043 17.5 9.625 17.5C11.1696 17.5 12.6915 17.8717 14.0621 18.5838C15.4328 19.2958 16.6119 20.3273 17.5 21.591"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5391 17.5C20.0838 17.499 21.606 17.8703 22.9768 18.5824C24.3476 19.2944 25.5266 20.3263 26.4141 21.5906"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function BrieftCaseIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.625 7.875H4.375C3.89175 7.875 3.5 8.26675 3.5 8.75V22.75C3.5 23.2332 3.89175 23.625 4.375 23.625H23.625C24.1082 23.625 24.5 23.2332 24.5 22.75V8.75C24.5 8.26675 24.1082 7.875 23.625 7.875Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.375 7.875V6.125C18.375 5.66087 18.1906 5.21575 17.8624 4.88756C17.5342 4.55937 17.0891 4.375 16.625 4.375H11.375C10.9109 4.375 10.4658 4.55937 10.1376 4.88756C9.80937 5.21575 9.625 5.66087 9.625 6.125V7.875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5 13.8145C21.3087 15.6601 17.6865 16.6298 14 16.6254C10.3128 16.635 6.68924 15.6649 3.5 13.8145"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6875 13.125H15.3125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UserFocusIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6875 4.375H22.75C22.9821 4.375 23.2046 4.46719 23.3687 4.63128C23.5328 4.79538 23.625 5.01794 23.625 5.25V8.3125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6875 23.625H22.75C22.9821 23.625 23.2046 23.5328 23.3687 23.3687C23.5328 23.2046 23.625 22.9821 23.625 22.75V19.6875"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3125 23.625H5.25C5.01794 23.625 4.79538 23.5328 4.63128 23.3687C4.46719 23.2046 4.375 22.9821 4.375 22.75V19.6875"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3125 4.375H5.25C5.01794 4.375 4.79538 4.46719 4.63128 4.63128C4.46719 4.79538 4.375 5.01794 4.375 5.25V8.3125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 15.75C15.933 15.75 17.5 14.183 17.5 12.25C17.5 10.317 15.933 8.75 14 8.75C12.067 8.75 10.5 10.317 10.5 12.25C10.5 14.183 12.067 15.75 14 15.75Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.19141 19.2504C8.75074 18.1953 9.58693 17.3125 10.6102 16.6969C11.6334 16.0812 12.805 15.7559 13.9992 15.7559C15.1934 15.7559 16.365 16.0812 17.3883 16.6969C18.4115 17.3125 19.2477 18.1953 19.807 19.2504"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function UserFocusIcon1({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6875 4.375H22.75C22.9821 4.375 23.2046 4.46719 23.3687 4.63128C23.5328 4.79538 23.625 5.01794 23.625 5.25V8.3125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6875 23.625H22.75C22.9821 23.625 23.2046 23.5328 23.3687 23.3687C23.5328 23.2046 23.625 22.9821 23.625 22.75V19.6875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3125 23.625H5.25C5.01794 23.625 4.79538 23.5328 4.63128 23.3687C4.46719 23.2046 4.375 22.9821 4.375 22.75V19.6875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3125 4.375H5.25C5.01794 4.375 4.79538 4.46719 4.63128 4.63128C4.46719 4.79538 4.375 5.01794 4.375 5.25V8.3125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 15.75C15.933 15.75 17.5 14.183 17.5 12.25C17.5 10.317 15.933 8.75 14 8.75C12.067 8.75 10.5 10.317 10.5 12.25C10.5 14.183 12.067 15.75 14 15.75Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.19141 19.2504C8.75074 18.1953 9.58693 17.3125 10.6102 16.6969C11.6334 16.0812 12.805 15.7559 13.9992 15.7559C15.1934 15.7559 16.365 16.0812 17.3883 16.6969C18.4115 17.3125 19.2477 18.1953 19.807 19.2504"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function DownArrow({ color }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.875 8.25L11 15.125L4.125 8.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function UserIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 17.5C17.866 17.5 21 14.366 21 10.5C21 6.63401 17.866 3.5 14 3.5C10.134 3.5 7 6.63401 7 10.5C7 14.366 10.134 17.5 14 17.5Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M3.39062 23.625C4.46571 21.7625 6.01216 20.2158 7.87451 19.1405C9.73686 18.0652 11.8495 17.499 14 17.499C16.1505 17.499 18.2631 18.0652 20.1255 19.1405C21.9878 20.2158 23.5343 21.7625 24.6094 23.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function UserIconCol({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 17.5C17.866 17.5 21 14.366 21 10.5C21 6.63401 17.866 3.5 14 3.5C10.134 3.5 7 6.63401 7 10.5C7 14.366 10.134 17.5 14 17.5Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M3.39062 23.625C4.46571 21.7625 6.01216 20.2158 7.87451 19.1405C9.73686 18.0652 11.8495 17.499 14 17.499C16.1505 17.499 18.2631 18.0652 20.1255 19.1405C21.9878 20.2158 23.5343 21.7625 24.6094 23.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ReportIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 14H17.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 17.5H17.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.125 4.375H21.875C22.1071 4.375 22.3296 4.46719 22.4937 4.63128C22.6578 4.79538 22.75 5.01794 22.75 5.25V21.875C22.75 22.5712 22.4734 23.2389 21.9812 23.7312C21.4889 24.2234 20.8212 24.5 20.125 24.5H7.875C7.17881 24.5 6.51113 24.2234 6.01884 23.7312C5.52656 23.2389 5.25 22.5712 5.25 21.875V5.25C5.25 5.01794 5.34219 4.79538 5.50628 4.63128C5.67038 4.46719 5.89294 4.375 6.125 4.375V4.375Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 2.625V6.125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2.625V6.125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 2.625V6.125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SettingIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 19.25C16.8995 19.25 19.25 16.8995 19.25 14C19.25 11.1005 16.8995 8.75 14 8.75C11.1005 8.75 8.75 11.1005 8.75 14C8.75 16.8995 11.1005 19.25 14 19.25Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.093 7.12061C20.3701 7.37581 20.6326 7.63831 20.8805 7.90811L23.8664 8.33467C24.3529 9.1796 24.7279 10.084 24.982 11.0253L23.1664 13.4425C23.1664 13.4425 23.1992 14.1862 23.1664 14.5581L24.982 16.9753C24.7291 17.917 24.354 18.8215 23.8664 19.6659L20.8805 20.0925C20.8805 20.0925 20.3664 20.6284 20.093 20.88L19.6664 23.8659C18.8215 24.3524 17.9171 24.7274 16.9758 24.9815L14.5586 23.1659C14.1874 23.1987 13.8141 23.1987 13.443 23.1659L11.0258 24.9815C10.0841 24.7286 9.17954 24.3536 8.33516 23.8659L7.90859 20.88C7.6388 20.6248 7.3763 20.3623 7.12109 20.0925L4.13516 19.6659C3.64864 18.821 3.27364 17.9166 3.01953 16.9753L4.83516 14.5581C4.83516 14.5581 4.80234 13.8144 4.83516 13.4425L3.01953 11.0253C3.27246 10.0836 3.64752 9.17905 4.13516 8.33467L7.12109 7.90811C7.3763 7.63831 7.6388 7.37581 7.90859 7.12061L8.33516 4.13467C9.18009 3.64815 10.0845 3.27315 11.0258 3.01904L13.443 4.83467C13.8141 4.80185 14.1874 4.80185 14.5586 4.83467L16.9758 3.01904C17.9175 3.27197 18.822 3.64703 19.6664 4.13467L20.093 7.12061Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function FileIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4375 26.25H6.5625C6.31386 26.25 6.0754 26.1512 5.89959 25.9754C5.72377 25.7996 5.625 25.5611 5.625 25.3125V4.6875C5.625 4.43886 5.72377 4.2004 5.89959 4.02459C6.0754 3.84877 6.31386 3.75 6.5625 3.75H17.8125L24.375 10.3125V25.3125C24.375 25.5611 24.2762 25.7996 24.1004 25.9754C23.9246 26.1512 23.6861 26.25 23.4375 26.25Z"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8125 3.75V10.3125H24.375"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ThreeDotsIcon({ color }) {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 15.25C12.4665 15.25 13.25 14.4665 13.25 13.5C13.25 12.5335 12.4665 11.75 11.5 11.75C10.5335 11.75 9.75 12.5335 9.75 13.5C9.75 14.4665 10.5335 15.25 11.5 15.25Z"
        fill={color}
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M11.5 5.75C12.4665 5.75 13.25 4.9665 13.25 4C13.25 3.0335 12.4665 2.25 11.5 2.25C10.5335 2.25 9.75 3.0335 9.75 4C9.75 4.9665 10.5335 5.75 11.5 5.75Z"
        fill={color}
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M11.5 24.75C12.4665 24.75 13.25 23.9665 13.25 23C13.25 22.0335 12.4665 21.25 11.5 21.25C10.5335 21.25 9.75 22.0335 9.75 23C9.75 23.9665 10.5335 24.75 11.5 24.75Z"
        fill={color}
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function BellICon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7295 21C13.5537 21.3031 13.3014 21.5547 12.9978 21.7295C12.6941 21.9044 12.3499 21.9965 11.9995 21.9965C11.6492 21.9965 11.3049 21.9044 11.0013 21.7295C10.6977 21.5547 10.4453 21.3031 10.2695 21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function UploadIcon({ color }) {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7734 13.1328L20.5 6.40625L27.2266 13.1328"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 24.3438V6.40625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5938 24.3438V33.3125C34.5938 33.6523 34.4588 33.9782 34.2185 34.2185C33.9782 34.4588 33.6523 34.5938 33.3125 34.5938H7.6875C7.34769 34.5938 7.0218 34.4588 6.78152 34.2185C6.54124 33.9782 6.40625 33.6523 6.40625 33.3125V24.3438"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CaretRightIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4.5L16.5 12L9 19.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SignOutIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0312 9.40625L23.625 14L19.0312 18.5938"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 14H23.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 23.625H5.25C5.01794 23.625 4.79538 23.5328 4.63128 23.3687C4.46719 23.2046 4.375 22.9821 4.375 22.75V5.25C4.375 5.01794 4.46719 4.79538 4.63128 4.63128C4.79538 4.46719 5.01794 4.375 5.25 4.375H11.375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function EditIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.69063 20.2516H4.5C4.30109 20.2516 4.11033 20.1726 3.96967 20.032C3.82902 19.8913 3.75 19.7005 3.75 19.5016V15.311C3.74966 15.2136 3.76853 15.1171 3.80553 15.027C3.84253 14.9369 3.89694 14.855 3.96563 14.786L15.2156 3.536C15.2854 3.46514 15.3686 3.40886 15.4603 3.37045C15.5521 3.33204 15.6506 3.31226 15.75 3.31226C15.8495 3.31226 15.9479 3.33204 16.0397 3.37045C16.1314 3.40886 16.2146 3.46514 16.2844 3.536L20.4656 7.71725C20.5365 7.78704 20.5928 7.87022 20.6312 7.96197C20.6696 8.05371 20.6894 8.15217 20.6894 8.25163C20.6894 8.35109 20.6696 8.44955 20.6312 8.54129C20.5928 8.63303 20.5365 8.71622 20.4656 8.786L9.21563 20.036C9.1466 20.1047 9.06469 20.1591 8.97461 20.1961C8.88452 20.2331 8.78802 20.252 8.69063 20.2516V20.2516Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 6L18 11.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function TagEditIcon({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.69063 20.2516H4.5C4.30109 20.2516 4.11033 20.1726 3.96967 20.032C3.82902 19.8913 3.75 19.7005 3.75 19.5016V15.311C3.74966 15.2136 3.76853 15.1171 3.80553 15.027C3.84253 14.9369 3.89694 14.855 3.96563 14.786L15.2156 3.536C15.2854 3.46514 15.3686 3.40886 15.4603 3.37045C15.5521 3.33204 15.6506 3.31226 15.75 3.31226C15.8495 3.31226 15.9479 3.33204 16.0397 3.37045C16.1314 3.40886 16.2146 3.46514 16.2844 3.536L20.4656 7.71725C20.5365 7.78704 20.5928 7.87022 20.6312 7.96197C20.6696 8.05371 20.6894 8.15217 20.6894 8.25163C20.6894 8.35109 20.6696 8.44955 20.6312 8.54129C20.5928 8.63303 20.5365 8.71622 20.4656 8.786L9.21563 20.036C9.1466 20.1047 9.06469 20.1591 8.97461 20.1961C8.88452 20.2331 8.78802 20.252 8.69063 20.2516V20.2516Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 6L18 11.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CakeIcon({ color }) {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10.625V8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9987 8C19.0519 6.25 13.9987 1.875 13.9987 1.875C13.9987 1.875 8.74874 6.25 13.9987 8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7188 14.7812C17.7188 15.7675 17.327 16.7134 16.6296 17.4108C15.9322 18.1082 14.9863 18.5 14 18.5C13.0137 18.5 12.0678 18.1082 11.3704 17.4108C10.673 16.7134 10.2812 15.7675 10.2812 14.7812"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2813 14.7813C10.2815 15.7544 9.90021 16.6889 9.21928 17.3841C8.53836 18.0794 7.61203 18.48 6.63909 18.5C4.55002 18.5438 2.84377 16.7938 2.84377 14.7047V13.25C2.84233 12.9049 2.90924 12.5629 3.04064 12.2438C3.17205 11.9246 3.36535 11.6347 3.60939 11.3906C3.85343 11.1466 4.14339 10.9533 4.46252 10.8219C4.78165 10.6905 5.12365 10.6236 5.46877 10.625H22.5313C22.8764 10.6236 23.2184 10.6905 23.5375 10.8219C23.8567 10.9533 24.1466 11.1466 24.3907 11.3906C24.6347 11.6347 24.828 11.9246 24.9594 12.2438C25.0908 12.5629 25.1577 12.9049 25.1563 13.25V14.7047C25.1563 16.7938 23.45 18.5438 21.361 18.5C20.388 18.48 19.4617 18.0794 18.7808 17.3841C18.0998 16.6889 17.7186 15.7544 17.7188 14.7813"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.625 17.7673V23.7501C23.625 23.9822 23.5328 24.2048 23.3687 24.3689C23.2046 24.533 22.9821 24.6251 22.75 24.6251H5.25C5.01794 24.6251 4.79538 24.533 4.63128 24.3689C4.46719 24.2048 4.375 23.9822 4.375 23.7501V17.7673"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function GenderIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.125 18.375C16.7494 18.375 19.6875 15.4369 19.6875 11.8125C19.6875 8.18813 16.7494 5.25 13.125 5.25C9.50063 5.25 6.5625 8.18813 6.5625 11.8125C6.5625 15.4369 9.50063 18.375 13.125 18.375Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 18.375V25.375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 22.3125H16.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.375 2.625H22.75V7"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9799 7.39375L22.7487 2.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function BuildIcon({ color }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.625 21.9375H24.375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M14.625 21.9375V4.0625C14.625 3.84701 14.5394 3.64035 14.387 3.48798C14.2347 3.3356 14.028 3.25 13.8125 3.25H4.0625C3.84701 3.25 3.64035 3.3356 3.48798 3.48798C3.3356 3.64035 3.25 3.84701 3.25 4.0625V21.9375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M22.75 21.9375V10.5625C22.75 10.347 22.6644 10.1403 22.512 9.98798C22.3597 9.8356 22.153 9.75 21.9375 9.75H14.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 7.3125H9.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M8.125 13.8125H11.375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M6.5 17.875H9.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M17.875 17.875H19.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M17.875 13.8125H19.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SutCaseTab({ color }) {
  return (
    <svg
      id="sutCaseTabIcon"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="sutCaseTabIcon"
        d="M21.9375 7.3125H4.0625C3.61377 7.3125 3.25 7.67627 3.25 8.125V21.125C3.25 21.5737 3.61377 21.9375 4.0625 21.9375H21.9375C22.3862 21.9375 22.75 21.5737 22.75 21.125V8.125C22.75 7.67627 22.3862 7.3125 21.9375 7.3125Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="sutCaseTabIcon"
        d="M17.0625 7.3125V5.6875C17.0625 5.25652 16.8913 4.8432 16.5865 4.53845C16.2818 4.2337 15.8685 4.0625 15.4375 4.0625H10.5625C10.1315 4.0625 9.7182 4.2337 9.41345 4.53845C9.10871 4.8432 8.9375 5.25652 8.9375 5.6875V7.3125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        id="sutCaseTabIcon"
        d="M22.75 12.8279C19.7867 14.5417 16.4232 15.4421 13 15.438C9.57618 15.4469 6.21144 14.5462 3.25 12.8279"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        id="sutCaseTabIcon"
        d="M11.7812 12.1875H14.2188"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PhoneIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1172 13.6509C11.0176 15.5103 12.5211 17.01 14.3828 17.9056C14.5201 17.9706 14.672 17.9987 14.8235 17.9872C14.975 17.9757 15.1209 17.925 15.2469 17.84L17.9812 16.0134C18.1021 15.9314 18.2417 15.8815 18.387 15.8681C18.5324 15.8547 18.6788 15.8783 18.8125 15.9368L23.9312 18.1353C24.1062 18.2081 24.2524 18.3364 24.3472 18.5004C24.4421 18.6645 24.4804 18.8551 24.4562 19.0431C24.294 20.3094 23.6759 21.4731 22.7177 22.3166C21.7594 23.1602 20.5266 23.6256 19.25 23.6259C15.3049 23.6259 11.5214 22.0587 8.73179 19.2691C5.94218 16.4795 4.375 12.696 4.375 8.75089C4.37529 7.47426 4.84073 6.24148 5.68425 5.28322C6.52776 4.32495 7.69153 3.70688 8.95781 3.54464C9.14576 3.5205 9.33643 3.55881 9.50047 3.65367C9.66451 3.74854 9.79281 3.8947 9.86562 4.06964L12.0641 9.19933C12.1212 9.33096 12.1451 9.47463 12.1337 9.61768C12.1223 9.76073 12.0758 9.89877 11.9984 10.0196L10.1719 12.7978C10.0906 12.9234 10.0428 13.0678 10.0333 13.2172C10.0237 13.3666 10.0526 13.5159 10.1172 13.6509V13.6509Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function HomeIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.625 22.7508V17.5008C16.625 17.2688 16.5328 17.0462 16.3687 16.8821C16.2046 16.718 15.9821 16.6258 15.75 16.6258H12.25C12.0179 16.6258 11.7954 16.718 11.6313 16.8821C11.4672 17.0462 11.375 17.2688 11.375 17.5008V22.7508C11.375 22.9829 11.2828 23.2055 11.1187 23.3696C10.9546 23.5337 10.7321 23.6258 10.5 23.6258H5.25C5.01794 23.6258 4.79538 23.5337 4.63128 23.3696C4.46719 23.2055 4.375 22.9829 4.375 22.7508V12.6337C4.37696 12.5126 4.40313 12.3931 4.45197 12.2823C4.50081 12.1714 4.57133 12.0715 4.65937 11.9883L13.4094 4.03678C13.5707 3.88921 13.7814 3.80737 14 3.80737C14.2186 3.80737 14.4293 3.88921 14.5906 4.03678L23.3406 11.9883C23.4287 12.0715 23.4992 12.1714 23.548 12.2823C23.5969 12.3931 23.623 12.5126 23.625 12.6337V22.7508C23.625 22.9829 23.5328 23.2055 23.3687 23.3696C23.2046 23.5337 22.9821 23.6258 22.75 23.6258H17.5C17.2679 23.6258 17.0454 23.5337 16.8813 23.3696C16.7172 23.2055 16.625 22.9829 16.625 22.7508Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function EnvelopeIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 6.125H24.5V21C24.5 21.2321 24.4078 21.4546 24.2437 21.6187C24.0796 21.7828 23.8571 21.875 23.625 21.875H4.375C4.14294 21.875 3.92038 21.7828 3.75628 21.6187C3.59219 21.4546 3.5 21.2321 3.5 21V6.125Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5 6.125L14 15.75L3.5 6.125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Editicon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.69063 20.2516H4.5C4.30109 20.2516 4.11033 20.1726 3.96967 20.032C3.82902 19.8913 3.75 19.7005 3.75 19.5016V15.311C3.74966 15.2136 3.76853 15.1171 3.80553 15.027C3.84253 14.9369 3.89694 14.855 3.96563 14.786L15.2156 3.536C15.2854 3.46514 15.3686 3.40886 15.4603 3.37045C15.5521 3.33204 15.6506 3.31226 15.75 3.31226C15.8495 3.31226 15.9479 3.33204 16.0397 3.37045C16.1314 3.40886 16.2146 3.46514 16.2844 3.536L20.4656 7.71725C20.5365 7.78704 20.5928 7.87022 20.6312 7.96197C20.6696 8.05371 20.6894 8.15217 20.6894 8.25163C20.6894 8.35109 20.6696 8.44955 20.6312 8.54129C20.5928 8.63303 20.5365 8.71622 20.4656 8.786L9.21563 20.036C9.1466 20.1047 9.06469 20.1591 8.97461 20.1961C8.88452 20.2331 8.78802 20.252 8.69063 20.2516V20.2516Z"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 6L18 11.25"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CameraIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.75 22.75H5.25C4.78587 22.75 4.34075 22.5656 4.01256 22.2374C3.68437 21.9092 3.5 21.4641 3.5 21V8.75C3.5 8.28587 3.68437 7.84075 4.01256 7.51256C4.34075 7.18437 4.78587 7 5.25 7H8.75L10.5 4.375H17.5L19.25 7H22.75C23.2141 7 23.6592 7.18437 23.9874 7.51256C24.3156 7.84075 24.5 8.28587 24.5 8.75V21C24.5 21.4641 24.3156 21.9092 23.9874 22.2374C23.6592 22.5656 23.2141 22.75 22.75 22.75Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 18.375C16.1746 18.375 17.9375 16.6121 17.9375 14.4375C17.9375 12.2629 16.1746 10.5 14 10.5C11.8254 10.5 10.0625 12.2629 10.0625 14.4375C10.0625 16.6121 11.8254 18.375 14 18.375Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ProfileIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MapPinIcon({ color }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 13.8125C14.7949 13.8125 16.25 12.3574 16.25 10.5625C16.25 8.76757 14.7949 7.3125 13 7.3125C11.2051 7.3125 9.75 8.76757 9.75 10.5625C9.75 12.3574 11.2051 13.8125 13 13.8125Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.125 10.5625C21.125 17.875 13 23.5625 13 23.5625C13 23.5625 4.875 17.875 4.875 10.5625C4.875 8.40762 5.73102 6.34099 7.25476 4.81726C8.77849 3.29352 10.8451 2.4375 13 2.4375C15.1549 2.4375 17.2215 3.29352 18.7452 4.81726C20.269 6.34099 21.125 8.40762 21.125 10.5625V10.5625Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EditIconBlueClr({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.69063 20.2516H4.5C4.30109 20.2516 4.11033 20.1726 3.96967 20.032C3.82902 19.8913 3.75 19.7005 3.75 19.5016V15.311C3.74966 15.2136 3.76853 15.1171 3.80553 15.027C3.84253 14.9369 3.89694 14.855 3.96563 14.786L15.2156 3.536C15.2854 3.46514 15.3686 3.40886 15.4603 3.37045C15.5521 3.33204 15.6506 3.31226 15.75 3.31226C15.8495 3.31226 15.9479 3.33204 16.0397 3.37045C16.1314 3.40886 16.2146 3.46514 16.2844 3.536L20.4656 7.71725C20.5365 7.78704 20.5928 7.87022 20.6312 7.96197C20.6696 8.05371 20.6894 8.15217 20.6894 8.25163C20.6894 8.35109 20.6696 8.44955 20.6312 8.54129C20.5928 8.63303 20.5365 8.71622 20.4656 8.786L9.21563 20.036C9.1466 20.1047 9.06469 20.1591 8.97461 20.1961C8.88452 20.2331 8.78802 20.252 8.69063 20.2516V20.2516Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 6L18 11.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DeleteIconBlueClr({ color }) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.25 4.25H1.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 8.75V14.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 8.75V14.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.75 4.25V18.5C16.75 18.6989 16.671 18.8897 16.5303 19.0303C16.3897 19.171 16.1989 19.25 16 19.25H4C3.80109 19.25 3.61032 19.171 3.46967 19.0303C3.32902 18.8897 3.25 18.6989 3.25 18.5V4.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 4.25V2.75C13.75 2.35218 13.592 1.97064 13.3107 1.68934C13.0294 1.40804 12.6478 1.25 12.25 1.25H7.75C7.35218 1.25 6.97064 1.40804 6.68934 1.68934C6.40804 1.97064 6.25 2.35218 6.25 2.75V4.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PlusIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 12H20.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3.75V20.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function PlusForButtonIcon({ color, height, width }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 12H20.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3.75V20.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BoldIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11.25H14.25C15.2446 11.25 16.1984 11.6451 16.9017 12.3483C17.6049 13.0516 18 14.0054 18 15C18 15.9946 17.6049 16.9484 16.9017 17.6517C16.1984 18.3549 15.2446 18.75 14.25 18.75H6V4.5H13.125C14.0201 4.5 14.8785 4.85558 15.5115 5.48851C16.1444 6.12145 16.5 6.97989 16.5 7.875C16.5 8.77011 16.1444 9.62855 15.5115 10.2615C14.8785 10.8944 14.0201 11.25 13.125 11.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ItalicIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 5.25L9.75 18.75"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 18.75H13.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 5.25H18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UnderlineIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 20.25H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 5.25V11.25C6 12.8413 6.63214 14.3674 7.75736 15.4926C8.88258 16.6179 10.4087 17.25 12 17.25C13.5913 17.25 15.1174 16.6179 16.2426 15.4926C17.3679 14.3674 18 12.8413 18 11.25V5.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UnorderdListIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 6H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 12H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 18H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.125 7.125C4.74632 7.125 5.25 6.62132 5.25 6C5.25 5.37868 4.74632 4.875 4.125 4.875C3.50368 4.875 3 5.37868 3 6C3 6.62132 3.50368 7.125 4.125 7.125Z"
        fill="black"
      />
      <path
        d="M4.125 13.125C4.74632 13.125 5.25 12.6213 5.25 12C5.25 11.3787 4.74632 10.875 4.125 10.875C3.50368 10.875 3 11.3787 3 12C3 12.6213 3.50368 13.125 4.125 13.125Z"
        fill="black"
      />
      <path
        d="M4.125 19.125C4.74632 19.125 5.25 18.6213 5.25 18C5.25 17.3787 4.74632 16.875 4.125 16.875C3.50368 16.875 3 17.3787 3 18C3 18.6213 3.50368 19.125 4.125 19.125Z"
        fill="black"
      />
    </svg>
  );
}

export function DownArrowIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.58891 9.7845C5.63478 9.85112 5.69616 9.90559 5.76775 9.94323C5.83935 9.98086 5.91902 10.0005 5.99991 10.0005C6.08079 10.0005 6.16047 9.98086 6.23206 9.94323C6.30366 9.90559 6.36504 9.85112 6.41091 9.7845L10.9109 3.2845C10.963 3.20953 10.9935 3.12172 10.9992 3.0306C11.0049 2.93949 10.9855 2.84856 10.9432 2.7677C10.9008 2.68683 10.8371 2.61912 10.7589 2.57193C10.6808 2.52473 10.5912 2.49986 10.4999 2.5H1.49991C1.40883 2.50038 1.31958 2.52557 1.24175 2.57288C1.16392 2.62019 1.10046 2.68782 1.05819 2.7685C1.01592 2.84917 0.99645 2.93985 1.00186 3.03077C1.00727 3.12168 1.03737 3.20941 1.08891 3.2845L5.58891 9.7845Z"
        fill="black"
      />
    </svg>
  );
}

export function OrderedListBoldIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 12H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 6H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 18H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 5.625L5.25 4.875V10.125"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.85312 14.3083C3.92224 14.1372 4.02666 13.9826 4.15958 13.8545C4.2925 13.7265 4.45093 13.6279 4.62452 13.5653C4.79812 13.5026 4.98297 13.4773 5.16703 13.4909C5.35108 13.5045 5.53019 13.5568 5.69266 13.6443C5.85514 13.7319 5.99733 13.8527 6.10994 13.9989C6.22256 14.1451 6.30308 14.3134 6.34624 14.4929C6.38939 14.6723 6.39422 14.8588 6.36041 15.0403C6.3266 15.2217 6.2549 15.394 6.15 15.5458L3.75 18.7521H6.375"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TextAlignLeftIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 6.375H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 10.125H15.75"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 13.875H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 17.625H15.75"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DropIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 13.5C19.5 6.75 12 1.5 12 1.5C12 1.5 4.5 6.75 4.5 13.5C4.5 15.4891 5.29018 17.3968 6.6967 18.8033C8.10322 20.2098 10.0109 21 12 21C13.9891 21 15.8968 20.2098 17.3033 18.8033C18.7098 17.3968 19.5 15.4891 19.5 13.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7588 17.9283C13.6755 17.7729 14.5213 17.3368 15.1796 16.6803C15.8378 16.0237 16.2761 15.179 16.4338 14.2627"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LinkIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.82129 15.1781L15.1775 8.8125"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.593 16.7719L10.9398 19.425C10.5219 19.843 10.0257 20.1745 9.47956 20.4007C8.93345 20.6269 8.34814 20.7434 7.75704 20.7434C6.56325 20.7434 5.41836 20.2691 4.57422 19.425C3.73009 18.5809 3.25586 17.436 3.25586 16.2422C3.25586 15.0484 3.73009 13.9035 4.57422 13.0594L7.22735 10.4062"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7719 13.593L19.425 10.9398C20.2691 10.0957 20.7434 8.95082 20.7434 7.75704C20.7434 6.56325 20.2691 5.41836 19.425 4.57422C18.5809 3.73009 17.436 3.25586 16.2422 3.25586C15.0484 3.25586 13.9035 3.73009 13.0594 4.57422L10.4062 7.22735"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ImageIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 4.5H3.75C3.33579 4.5 3 4.83579 3 5.25V18.75C3 19.1642 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.1642 21 18.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 15.7521L7.71563 11.0365C7.78541 10.9656 7.8686 10.9094 7.96034 10.8709C8.05208 10.8325 8.15054 10.8127 8.25 10.8127C8.34946 10.8127 8.44792 10.8325 8.53966 10.8709C8.6314 10.9094 8.71459 10.9656 8.78437 11.0365L12.9656 15.2177C13.0354 15.2886 13.1186 15.3449 13.2103 15.3833C13.3021 15.4217 13.4005 15.4415 13.5 15.4415C13.5995 15.4415 13.6979 15.4217 13.7897 15.3833C13.8814 15.3449 13.9646 15.2886 14.0344 15.2177L15.9656 13.2865C16.0354 13.2156 16.1186 13.1594 16.2103 13.1209C16.3021 13.0825 16.4005 13.0627 16.5 13.0627C16.5995 13.0627 16.6979 13.0825 16.7897 13.1209C16.8814 13.1594 16.9646 13.2156 17.0344 13.2865L21 17.2521"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.625 10.5C15.2463 10.5 15.75 9.99632 15.75 9.375C15.75 8.75368 15.2463 8.25 14.625 8.25C14.0037 8.25 13.5 8.75368 13.5 9.375C13.5 9.99632 14.0037 10.5 14.625 10.5Z"
        fill="black"
      />
    </svg>
  );
}

export function CameraTextareaIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 5.625H14.25C15.0456 5.625 15.8087 5.94107 16.3713 6.50368C16.9339 7.06629 17.25 7.82935 17.25 8.625V17.625C17.25 17.8239 17.171 18.0147 17.0303 18.1553C16.8897 18.296 16.6989 18.375 16.5 18.375H4.5C3.70435 18.375 2.94129 18.0589 2.37868 17.4963C1.81607 16.9337 1.5 16.1706 1.5 15.375V6.375C1.5 6.17609 1.57902 5.98532 1.71967 5.84467C1.86032 5.70402 2.05109 5.625 2.25 5.625V5.625Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.25 10.5L22.5 7.5V16.5L17.25 13.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CodeIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8.25L1.5 12L6 15.75"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 8.25L22.5 12L18 15.75"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 3.75L9 20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function PaperPlane({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3334 3.42206L2.46461 19.2564C2.39093 19.3898 2.35962 19.5425 2.37485 19.6941C2.39009 19.8457 2.45114 19.9891 2.54989 20.1051C2.64863 20.2212 2.78039 20.3044 2.92761 20.3437C3.07483 20.383 3.23053 20.3766 3.37399 20.3252L11.7365 17.3439C11.8988 17.2783 12.0804 17.2783 12.2427 17.3439L20.6052 20.3252C20.7487 20.3766 20.9044 20.383 21.0516 20.3437C21.1988 20.3044 21.3306 20.2212 21.4293 20.1051C21.5281 19.9891 21.5891 19.8457 21.6044 19.6941C21.6196 19.5425 21.5883 19.3898 21.5146 19.2564L12.6459 3.42206C12.581 3.30484 12.4859 3.20713 12.3705 3.13908C12.2551 3.07104 12.1236 3.03516 11.9896 3.03516C11.8556 3.03516 11.7241 3.07104 11.6087 3.13908C11.4933 3.20713 11.3982 3.30484 11.3334 3.42206Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9902 17.25V11.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function BackButtonIcon({ color }) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 24.375L9.375 15L18.75 5.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}


export function CalendarBlankIcon({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 3.125H3.75C3.40482 3.125 3.125 3.40482 3.125 3.75V16.25C3.125 16.5952 3.40482 16.875 3.75 16.875H16.25C16.5952 16.875 16.875 16.5952 16.875 16.25V3.75C16.875 3.40482 16.5952 3.125 16.25 3.125Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 1.875V4.375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 1.875V4.375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 6.875H16.875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function CaretBlackDownIcon({ color }) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 9L12 16.5L4.5 9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function CaretBlackRightIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4.5L16.5 12L9 19.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function FunnelIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.61697 4.125H18.381C18.5144 4.12504 18.6449 4.16387 18.7565 4.23675C18.8682 4.30963 18.9563 4.41341 19.01 4.53546C19.0638 4.65751 19.0808 4.79255 19.0592 4.92414C19.0375 5.05572 18.9781 5.17817 18.8881 5.27656L13.242 11.4898C13.1245 11.6156 13.0598 11.7818 13.0615 11.9539V16.818C13.0626 16.9322 13.0347 17.0449 12.9807 17.1455C12.9266 17.2462 12.848 17.3316 12.7521 17.3937L10.0021 19.2242C9.89897 19.2922 9.77941 19.3311 9.65603 19.3368C9.53264 19.3426 9.40998 19.315 9.30094 19.257C9.19191 19.1989 9.10052 19.1126 9.03639 19.007C8.97226 18.9014 8.93775 18.7805 8.9365 18.657V11.9539C8.93816 11.7818 8.87354 11.6156 8.75603 11.4898L3.10994 5.27656C3.01992 5.17817 2.96047 5.05572 2.93881 4.92414C2.91716 4.79255 2.93424 4.65751 2.98798 4.53546C3.04172 4.41341 3.12979 4.30963 3.24147 4.23675C3.35315 4.16387 3.48361 4.12504 3.61697 4.125V4.125Z"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function CloseIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 5.25L5.25 18.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 18.75L5.25 5.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CloseIconSmall({ color }) {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 5.25L5.25 18.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 18.75L5.25 5.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function BrieftCaseAddIcon({ color }) {
  return (
    <svg
      width="98"
      height="98"
      viewBox="0 0 98 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60.958 15.9459H75.581C79.25 15.9459 82.2196 18.9111 82.2196 22.5833V47.4165C88.4129 49.6056 92.8498 55.5118 92.8498 62.4553C92.8498 71.2621 85.7109 78.4013 76.9038 78.4013C70.4687 78.4013 64.9234 74.5891 62.404 69.0995H11.787C8.11798 69.0995 5.14844 66.1343 5.14844 62.4627V22.5851C5.14844 18.9221 8.12722 15.9477 11.787 15.9477H26.41V6.64047C26.41 2.97373 29.3763 0.00195312 33.0408 0.00195312H54.3278C57.9875 0.00195312 60.9586 2.98129 60.9586 6.64047L60.958 15.9459ZM61.4606 66.4411C61.1325 65.1668 60.958 63.8308 60.958 62.4543C60.958 59.1944 61.937 56.1625 63.6158 53.6371V18.6035H23.7508V66.4415L61.4606 66.4411ZM66.2737 50.5693C69.0944 48.0444 72.8204 46.5087 76.9039 46.5087C77.8095 46.5087 78.6976 46.5842 79.5616 46.7291V22.5833C79.5616 20.38 77.7827 18.6036 75.5809 18.6036H66.2737V50.5693ZM76.9039 75.7427C84.243 75.7427 90.1924 69.7938 90.1924 62.4547C90.1924 55.1156 84.243 49.1667 76.9039 49.1667C69.5654 49.1667 63.6159 55.1156 63.6159 62.4547C63.6159 69.7938 69.5654 75.7427 76.9039 75.7427ZM21.0943 18.6045H11.7871C9.59411 18.6045 7.80575 20.39 7.80575 22.5841V62.4617C7.80575 64.6645 9.58473 66.4413 11.7871 66.4413H21.0943V18.6045ZM29.0671 15.9467H58.3005V6.63949C58.3005 4.44653 56.5172 2.65873 54.3269 2.65873H33.0399C30.8442 2.65873 29.0669 4.43939 29.0669 6.63949L29.0671 15.9467ZM75.5751 61.1261V58.4689C75.5751 57.735 76.1696 57.14 76.9035 57.14C77.6374 57.14 78.2324 57.735 78.2324 58.4689V61.1261H80.8902C81.6241 61.1261 82.2191 61.7211 82.2191 62.455C82.2191 63.1889 81.6241 63.7839 80.8902 63.7839H78.2324V66.4417C78.2324 67.175 77.6374 67.77 76.9035 67.77C76.1696 67.77 75.5751 67.175 75.5751 66.4417V63.7839H72.9174C72.1835 63.7839 71.5885 63.1889 71.5885 62.455C71.5885 61.7211 72.1835 61.1261 72.9174 61.1261H75.5751Z"
        fill={color}
      />
    </svg>
  );
}
export function EditBorderIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function TrashIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H5H21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M10 11V17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M14 11V17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function FileAddIcon({ color }) {
  return (
    <svg
      width="99"
      height="99"
      viewBox="0 0 99 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M71.7746 32.1742H77.7384L76.7484 38.1574C76.6357 38.8313 77.0903 39.4689 77.7643 39.5821C77.8295 39.5932 77.8958 39.5992 77.9621 39.5992C78.5659 39.5987 79.0814 39.1617 79.1808 38.5661L80.4183 31.1411C80.4785 30.782 80.378 30.4152 80.1432 30.1379C79.9084 29.86 79.5631 29.6998 79.1996 29.6992H71.7746C71.0912 29.6992 70.5371 30.2533 70.5371 30.9367C70.5371 31.6201 71.0912 32.1742 71.7746 32.1742V32.1742Z"
        fill={color}
      />
      <path
        d="M40.8379 16.0871C40.8379 16.4153 40.9683 16.7302 41.2003 16.9622C41.4323 17.1942 41.7472 17.3246 42.0754 17.3246H69.3004C69.9838 17.3246 70.5379 16.7705 70.5379 16.0871C70.5379 15.4037 69.9838 14.8496 69.3004 14.8496H42.0754C41.392 14.8496 40.8379 15.4037 40.8379 16.0871Z"
        fill={color}
      />
      <path
        d="M69.3004 19.7988H42.0754C41.392 19.7988 40.8379 20.3529 40.8379 21.0363C40.8379 21.7197 41.392 22.2738 42.0754 22.2738H69.3004C69.9838 22.2738 70.5379 21.7197 70.5379 21.0363C70.5379 20.3529 69.9838 19.7988 69.3004 19.7988Z"
        fill={color}
      />
      <path
        d="M33.431 69.3H26.3573L25.3922 62.876C25.3485 62.5467 25.1745 62.2484 24.9088 62.049C24.643 61.8495 24.3083 61.765 23.9795 61.8147C23.6508 61.8644 23.3564 62.0445 23.1619 62.3141C22.9675 62.5832 22.8896 62.9196 22.9454 63.2472L24.068 70.7253C24.1608 71.3302 24.6817 71.776 25.2933 71.7749H33.431C34.1143 71.7749 34.6685 71.2208 34.6685 70.5374C34.6685 69.8541 34.1143 69.2999 33.431 69.2999L33.431 69.3Z"
        fill={color}
      />
      <path
        d="M82.9743 50.4398L86.1918 29.0191C86.3443 28.0186 86.0797 26.9999 85.4598 26.1998C84.84 25.3999 83.9189 24.8888 82.9124 24.7866V21.0371C82.9096 20.0532 82.5174 19.1107 81.8218 18.4151C81.1263 17.7196 80.1838 17.3274 79.1999 17.3246H75.4874V8.6621C75.4874 8.33394 75.357 8.01903 75.125 7.78701C74.893 7.55498 74.5781 7.4246 74.2499 7.4246H44.5499V6.1871C44.5471 5.20318 44.1549 4.2607 43.4594 3.56515C42.7638 2.86961 41.8213 2.47737 40.8374 2.47461H22.2749C21.291 2.47737 20.3485 2.86962 19.653 3.56515C18.9574 4.2607 18.5652 5.20318 18.5624 6.1871V24.7496H16.4836C15.4019 24.7513 14.3743 25.2231 13.6683 26.0429C12.9628 26.8627 12.649 27.9489 12.8081 29.019L19.4906 73.569C19.6221 74.4485 20.0657 75.2517 20.7408 75.8313C21.4154 76.4108 22.2766 76.7279 23.166 76.7246H70.5375C74.6202 76.7229 78.5492 75.1694 81.5287 72.3785C84.5086 69.5881 86.3157 65.7684 86.5842 61.6951C86.8527 57.6213 85.5621 53.5978 82.9745 50.4399L82.9743 50.4398ZM75.4874 19.7993H79.1999C79.528 19.7993 79.8429 19.9297 80.075 20.1617C80.307 20.3938 80.4374 20.7087 80.4374 21.0368V24.7493H75.4874V19.7993ZM73.0124 9.89933V24.7493H28.4624V19.7993H37.1249C37.453 19.7993 37.7679 19.6689 37.9999 19.4369C38.232 19.2049 38.3624 18.89 38.3624 18.5618V9.89933H73.0124ZM30.2076 17.3243L35.8879 11.644V17.3243H30.2076ZM21.0379 6.18683C21.0379 5.50344 21.592 4.94933 22.2754 4.94933H40.8379C41.1661 4.94933 41.481 5.07971 41.713 5.31174C41.945 5.54377 42.0754 5.85867 42.0754 6.18683V7.42433H37.1254C36.7973 7.42654 36.4829 7.55526 36.247 7.78343L26.347 17.6834C26.1189 17.9193 25.9901 18.2337 25.9879 18.5618V24.7493H21.0379V6.18683ZM23.1666 74.2493C22.5528 74.2537 22.0296 73.8046 21.9412 73.1974L15.2587 28.6475C15.2062 28.2917 15.3101 27.9309 15.5432 27.6575C15.778 27.3818 16.1222 27.2232 16.484 27.2243H82.5171C82.8789 27.2232 83.2231 27.3818 83.4579 27.6575C83.691 27.9309 83.7949 28.2917 83.7424 28.6475L80.7973 48.2735C77.3764 45.4244 72.9275 44.1219 68.5107 44.6764C64.0933 45.2305 60.1044 47.5928 57.4941 51.1992C54.8843 54.8057 53.8877 59.3331 54.7418 63.7024C55.5953 68.0712 58.2239 71.8904 61.9993 74.2487L23.1666 74.2493ZM77.6533 72.2572C74.1982 74.3824 69.977 74.8603 66.1341 73.5615C62.2912 72.2632 59.2251 69.3219 57.7672 65.5366C56.3098 61.7511 56.612 57.5138 58.5915 53.9731C60.5709 50.4324 64.0226 47.9557 68.0113 47.2155C71.9995 46.4747 76.1104 47.5464 79.2289 50.1402C82.3481 52.734 84.1513 56.5808 84.1502 60.6369C84.1529 65.3765 81.6928 69.7773 77.6532 72.2573L77.6533 72.2572Z"
        fill={color}
      />
      <path
        d="M79.1992 59.3988H71.7742V51.9738C71.7742 51.2904 71.2201 50.7363 70.5367 50.7363C69.8533 50.7363 69.2992 51.2904 69.2992 51.9738V59.3988H61.8742C61.1908 59.3988 60.6367 59.9529 60.6367 60.6363C60.6367 61.3197 61.1908 61.8738 61.8742 61.8738H69.2992V69.2988C69.2992 69.9822 69.8533 70.5363 70.5367 70.5363C71.2201 70.5363 71.7742 69.9822 71.7742 69.2988V61.8738H79.1992C79.8826 61.8738 80.4367 61.3197 80.4367 60.6363C80.4367 59.9529 79.8826 59.3988 79.1992 59.3988Z"
        fill={color}
      />
    </svg>
  );
}
export function DragOrUploadFile({ color }) {
  return (
    <svg
      width="99"
      height="99"
      viewBox="0 0 99 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6455 65.2788C11.2328 66.0936 12.1836 66.582 13.1863 66.582H58.541C58.5874 66.582 58.6267 66.5588 58.6731 66.5555C61.1182 71.2116 65.9428 74.4291 71.5564 74.4291C79.6085 74.4291 86.1617 67.8787 86.1617 59.8238C86.1617 55.956 84.6237 52.4611 82.1652 49.8481C82.1785 49.8149 82.205 49.7917 82.2182 49.7591L88.366 31.8005C88.7455 30.6851 88.94 29.5863 88.94 28.53C88.94 26.956 88.5074 25.5003 87.6859 24.3159C86.8445 23.1148 85.6562 22.2304 84.2867 21.7785C83.4155 21.4619 82.4354 21.3001 81.3791 21.3001H77.6234L77.6251 17.9141C77.6251 13.8519 74.312 10.4167 70.3945 10.4167H44.2359L40.6588 5.95845C40.0781 5.21595 39.161 4.77344 38.2136 4.77344H17.2878C13.3012 4.77344 10.0605 8.01413 10.0605 11.9973L10.0611 63.0983C10.0611 63.227 10.1009 63.3458 10.1335 63.4646C10.1335 64.1049 10.2589 64.7385 10.645 65.28L10.6455 65.2788ZM71.5574 71.7862C64.9605 71.7862 59.5951 66.4202 59.5951 59.8239C59.5951 53.2269 64.961 47.8615 71.5574 47.8615C78.1544 47.8615 83.5197 53.2275 83.5197 59.8239C83.5197 66.4202 78.1538 71.7862 71.5574 71.7862ZM83.4175 24.269C84.2821 24.5529 85.008 25.0905 85.5195 25.8198C86.0278 26.5556 86.2952 27.4926 86.2952 28.5257C86.2952 29.2914 86.1499 30.1063 85.8626 30.9383L80.0281 47.9762C77.6322 46.257 74.7185 45.2173 71.5534 45.2173C63.5013 45.2173 56.9481 51.7677 56.9481 59.8226C56.9481 61.2612 57.2221 62.6241 57.6116 63.9379H13.1832C13.0247 63.9379 12.876 63.8622 12.7904 63.7401C12.7015 63.6114 12.6783 63.4528 12.7308 63.2981L23.4788 31.9024C24.1925 29.803 25.7101 27.8097 27.7532 26.2823C29.7796 24.7707 32.043 23.9394 34.1224 23.9394H81.3779C82.1298 23.9394 82.8033 24.0449 83.4171 24.2692L83.4175 24.269ZM17.2883 7.41636H38.2141C38.3627 7.41636 38.5013 7.4821 38.5936 7.60143L42.5669 12.5613C42.8177 12.8746 43.1972 13.0563 43.6 13.0563H70.3936C72.8388 13.0563 74.984 15.327 74.984 17.9141V21.2968L34.1224 21.2963C31.479 21.2963 28.6575 22.3194 26.1759 24.1674C23.7108 26.0088 21.8628 28.454 20.9784 31.051L12.7053 55.224V12.0006C12.7053 9.47255 14.7616 7.41688 17.289 7.41688L17.2883 7.41636Z"
        fill={color}
      />
      <path
        d="M72.4058 52.2663C72.366 52.2332 72.3169 52.2232 72.2738 52.194C72.2705 52.1906 72.2672 52.1906 72.2672 52.1873C72.2174 52.1542 72.1716 52.1116 72.1185 52.0851C72.0788 52.0652 72.0395 52.0553 71.9998 52.0387C71.9373 52.0155 71.8744 52.0089 71.8119 51.9956C71.7462 51.9824 71.6865 51.9625 71.6208 51.9592C71.6009 51.9592 71.5843 51.9492 71.5644 51.9492C71.5412 51.9492 71.5247 51.9625 71.502 51.9625C71.4396 51.9658 71.3832 51.9824 71.3202 51.9956C71.2512 52.0089 71.1816 52.0188 71.1125 52.042C71.076 52.0553 71.0435 52.0652 71.007 52.0818C70.9473 52.1083 70.8982 52.1509 70.8418 52.1873C70.7987 52.2172 70.7462 52.2271 70.7065 52.2597L66.0205 56.2098C65.4631 56.6816 65.3935 57.513 65.8619 58.0677C66.1227 58.3777 66.4956 58.5395 66.8718 58.5395C67.1724 58.5395 67.4757 58.4373 67.7232 58.2263L70.2413 56.1043V66.364C70.2413 67.0932 70.8352 67.6838 71.5611 67.6838C72.287 67.6838 72.8809 67.0899 72.8809 66.364V56.111L75.3924 58.2263C75.6399 58.434 75.9438 58.5395 76.2437 58.5395C76.6166 58.5395 76.9929 58.3777 77.2536 58.0677C77.7254 57.5103 77.653 56.6783 77.0951 56.2098L72.4058 52.2663Z"
        fill={color}
      />
    </svg>
  );
}
export function EnvelopeForSummaryIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 5.25L12 13.5L3 5.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function DownloadIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.875 24.5H6.125C5.89294 24.5 5.67038 24.4078 5.50628 24.2437C5.34219 24.0796 5.25 23.8571 5.25 23.625V4.375C5.25 4.14294 5.34219 3.92038 5.50628 3.75628C5.67038 3.59219 5.89294 3.5 6.125 3.5H16.625L22.75 9.625V23.625C22.75 23.8571 22.6578 24.0796 22.4937 24.2437C22.3296 24.4078 22.1071 24.5 21.875 24.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.625 3.5V9.625H22.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9375 17.0625L14 20.125L17.0625 17.0625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 13.125V20.125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function PhoneForSummaryIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.67187 11.6998C9.44364 13.2935 10.7324 14.579 12.3281 15.3467C12.4458 15.4024 12.576 15.4265 12.7059 15.4167C12.8358 15.4068 12.9608 15.3633 13.0687 15.2904L15.4125 13.7248C15.516 13.6546 15.6357 13.6117 15.7603 13.6002C15.8849 13.5887 16.0104 13.609 16.125 13.6592L20.5125 15.5435C20.6625 15.6059 20.7877 15.7159 20.869 15.8565C20.9504 15.9971 20.9832 16.1606 20.9625 16.3217C20.8234 17.407 20.2937 18.4046 19.4723 19.1276C18.6509 19.8506 17.5943 20.2495 16.5 20.2498C13.1185 20.2498 9.87548 18.9065 7.48439 16.5154C5.0933 14.1243 3.75 10.8813 3.75 7.49979C3.75025 6.40553 4.1492 5.34886 4.87221 4.5275C5.59522 3.70613 6.59274 3.17635 7.67812 3.03729C7.83922 3.01659 8.00266 3.04943 8.14326 3.13074C8.28386 3.21206 8.39384 3.33733 8.45625 3.48729L10.3406 7.88416C10.3896 7.99699 10.4101 8.12013 10.4003 8.24275C10.3905 8.36537 10.3507 8.48369 10.2844 8.58729L8.71875 10.9685C8.64905 11.0762 8.60814 11.2 8.59993 11.328C8.59172 11.4561 8.61649 11.5841 8.67187 11.6998V11.6998Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function WhatsappIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.2565 16.5924C3.13983 14.7084 2.74924 12.4816 3.15804 10.33C3.56684 8.17843 4.74693 6.25006 6.47677 4.90691C8.2066 3.56377 10.3672 2.89821 12.553 3.03519C14.7388 3.17217 16.7994 4.10227 18.348 5.65088C19.8966 7.19949 20.8267 9.2601 20.9637 11.4459C21.1007 13.6316 20.4351 15.7923 19.0919 17.5221C17.7488 19.2519 15.8204 20.432 13.6689 20.8408C11.5173 21.2496 9.29049 20.859 7.4065 19.7424V19.7424L4.294 20.6236C4.16648 20.6609 4.03128 20.6632 3.90256 20.6303C3.77384 20.5974 3.65635 20.5304 3.5624 20.4365C3.46845 20.3425 3.4015 20.225 3.36858 20.0963C3.33565 19.9676 3.33796 19.8324 3.37525 19.7049L4.2565 16.5924Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2594 17.25C13.2726 17.2525 12.295 17.0599 11.3828 16.6834C10.4706 16.3069 9.64176 15.7539 8.94395 15.0561C8.24615 14.3583 7.69311 13.5295 7.3166 12.6173C6.9401 11.7051 6.74755 10.7275 6.75002 9.74065C6.7525 9.04608 7.03016 8.3808 7.52217 7.89055C8.01419 7.40029 8.68045 7.12502 9.37502 7.12502V7.12502C9.48962 7.12411 9.60234 7.1541 9.70133 7.21184C9.80032 7.26958 9.88191 7.35294 9.93752 7.45315L11.0344 9.36565C11.0996 9.48191 11.1331 9.61329 11.1315 9.74659C11.1298 9.87989 11.0931 10.0104 11.025 10.125L10.1438 11.5969C10.5952 12.601 11.399 13.4049 12.4031 13.8563L13.875 12.975C13.9896 12.9069 14.1202 12.8702 14.2535 12.8686C14.3868 12.8669 14.5181 12.9004 14.6344 12.9656L16.5469 14.0625C16.6471 14.1181 16.7305 14.1997 16.7882 14.2987C16.8459 14.3977 16.8759 14.5104 16.875 14.625C16.8726 15.3188 16.5965 15.9837 16.1068 16.4752C15.6171 16.9666 14.9532 17.2451 14.2594 17.25V17.25Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ClockIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12 6.75V12H17.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function HourglassIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12L6.3 7.725C6.20738 7.65464 6.13217 7.56395 6.08016 7.45992C6.02814 7.35589 6.00072 7.24131 6 7.125V3.75C6 3.55109 6.07902 3.36032 6.21967 3.21967C6.36032 3.07902 6.55109 3 6.75 3H17.25C17.4489 3 17.6397 3.07902 17.7803 3.21967C17.921 3.36032 18 3.55109 18 3.75V7.0875C17.9993 7.20381 17.9719 7.31839 17.9198 7.42242C17.8678 7.52645 17.7926 7.61714 17.7 7.6875L12 12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12L6.3 16.275C6.20738 16.3454 6.13217 16.436 6.08016 16.5401C6.02814 16.6441 6.00072 16.7587 6 16.875V20.25C6 20.4489 6.07902 20.6397 6.21967 20.7803C6.36032 20.921 6.55109 21 6.75 21H17.25C17.4489 21 17.6397 20.921 17.7803 20.7803C17.921 20.6397 18 20.4489 18 20.25V16.9125C17.9993 16.7962 17.9719 16.6816 17.9198 16.5776C17.8678 16.4735 17.7926 16.3829 17.7 16.3125L12 12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 16.9125L6 16.875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function DesktopTowerIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 17.25H3C2.60218 17.25 2.22064 17.092 1.93934 16.8107C1.65804 16.5294 1.5 16.1478 1.5 15.75V9C1.5 8.60218 1.65804 8.22064 1.93934 7.93934C2.22064 7.65804 2.60218 7.5 3 7.5H10.5"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 20.25H6"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 6.75H16.5"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 9.75H16.5"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.75 3.75H14.25C13.8358 3.75 13.5 4.08579 13.5 4.5V19.5C13.5 19.9142 13.8358 20.25 14.25 20.25H21.75C22.1642 20.25 22.5 19.9142 22.5 19.5V4.5C22.5 4.08579 22.1642 3.75 21.75 3.75Z"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 17.25V20.25"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0625 16.875C19.0625 17.4618 18.5868 17.9375 18 17.9375C17.4132 17.9375 16.9375 17.4618 16.9375 16.875C16.9375 16.2882 17.4132 15.8125 18 15.8125C18.5868 15.8125 19.0625 16.2882 19.0625 16.875Z"
        fill="#403e3e"
        stroke="#2F7BF5"
        strokeWidth="0.125"
      />
    </svg>
  );
}
export function UserPlusIcon({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_930_2440)">
        <path
          d="M13.3335 17.5V15.8333C13.3335 14.9493 12.9823 14.1014 12.3572 13.4763C11.7321 12.8512 10.8842 12.5 10.0002 12.5H4.16683C3.28277 12.5 2.43493 12.8512 1.80981 13.4763C1.18469 14.1014 0.833496 14.9493 0.833496 15.8333V17.5"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.08333 9.16667C8.92428 9.16667 10.4167 7.67428 10.4167 5.83333C10.4167 3.99238 8.92428 2.5 7.08333 2.5C5.24238 2.5 3.75 3.99238 3.75 5.83333C3.75 7.67428 5.24238 9.16667 7.08333 9.16667Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6665 6.66602V11.666"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1665 9.16602H14.1665"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_930_2440">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ClipBoardIcon({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 11.875H12.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.375H12.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 3.125H15.625C15.7908 3.125 15.9497 3.19085 16.0669 3.30806C16.1842 3.42527 16.25 3.58424 16.25 3.75V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.75C3.75 3.58424 3.81585 3.42527 3.93306 3.30806C4.05027 3.19085 4.20924 3.125 4.375 3.125H7.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 5.625V5C6.875 4.1712 7.20424 3.37634 7.79029 2.79029C8.37634 2.20424 9.1712 1.875 10 1.875C10.8288 1.875 11.6237 2.20424 12.2097 2.79029C12.7958 3.37634 13.125 4.1712 13.125 5V5.625H6.875Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Filedownload({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.875 24.5H6.125C5.89294 24.5 5.67038 24.4078 5.50628 24.2437C5.34219 24.0796 5.25 23.8571 5.25 23.625V4.375C5.25 4.14294 5.34219 3.92038 5.50628 3.75628C5.67038 3.59219 5.89294 3.5 6.125 3.5H16.625L22.75 9.625V23.625C22.75 23.8571 22.6578 24.0796 22.4937 24.2437C22.3296 24.4078 22.1071 24.5 21.875 24.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.625 3.5V9.625H22.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9375 17.0625L14 20.125L17.0625 17.0625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 13.125V20.125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FilterOutlinedIcon({ color }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.61697 4.125H18.381C18.5144 4.12504 18.6449 4.16387 18.7565 4.23675C18.8682 4.30963 18.9563 4.41341 19.01 4.53546C19.0638 4.65751 19.0808 4.79255 19.0592 4.92414C19.0375 5.05572 18.9781 5.17817 18.8881 5.27656L13.242 11.4898C13.1245 11.6156 13.0598 11.7818 13.0615 11.9539V16.818C13.0626 16.9322 13.0347 17.0449 12.9807 17.1455C12.9266 17.2462 12.848 17.3316 12.7521 17.3937L10.0021 19.2242C9.89897 19.2922 9.77941 19.3311 9.65603 19.3368C9.53264 19.3426 9.40998 19.315 9.30094 19.257C9.19191 19.1989 9.10052 19.1126 9.03639 19.007C8.97226 18.9014 8.93775 18.7805 8.9365 18.657V11.9539C8.93816 11.7818 8.87354 11.6156 8.75603 11.4898L3.10994 5.27656C3.01992 5.17817 2.96047 5.05572 2.93881 4.92414C2.91716 4.79255 2.93424 4.65751 2.98798 4.53546C3.04172 4.41341 3.12979 4.30963 3.24147 4.23675C3.35315 4.16387 3.48361 4.12504 3.61697 4.125V4.125Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NewIcon() {
  return (
    <svg
      width="42"
      height="17"
      viewBox="0 0 42 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="42" height="17" rx="8.5" fill="#A1FABA" />
      <path
        d="M12.64 11H11.72V3.84H12.84L16.32 9.41H16.36L16.32 8.03V3.84H17.24V11H16.28L12.64 5.16H12.6L12.64 6.54V11ZM20.7229 11.16C20.0029 11.16 19.4096 10.9133 18.9429 10.42C18.4762 9.92667 18.2429 9.30333 18.2429 8.55C18.2429 7.80333 18.4696 7.18333 18.9229 6.69C19.3762 6.19 19.9562 5.94 20.6629 5.94C21.3896 5.94 21.9662 6.17667 22.3929 6.65C22.8262 7.11667 23.0429 7.77333 23.0429 8.62L23.0329 8.72H19.1829C19.1962 9.2 19.3562 9.58667 19.6629 9.88C19.9696 10.1733 20.3362 10.32 20.7629 10.32C21.3496 10.32 21.8096 10.0267 22.1429 9.44L22.9629 9.84C22.7429 10.2533 22.4362 10.5767 22.0429 10.81C21.6562 11.0433 21.2162 11.16 20.7229 11.16ZM19.2529 7.96H22.0629C22.0362 7.62 21.8962 7.34 21.6429 7.12C21.3962 6.89333 21.0629 6.78 20.6429 6.78C20.2962 6.78 19.9962 6.88667 19.7429 7.1C19.4962 7.31333 19.3329 7.6 19.2529 7.96ZM30.7266 6.1L29.1466 11H28.2066L26.9866 7.24L25.7766 11H24.8466L23.2666 6.1H24.2266L25.3166 9.8H25.3266L26.5366 6.1H27.4866L28.6966 9.8H28.7066L29.7866 6.1H30.7266Z"
        fill="#015218"
      />
    </svg>
  );
}

export function GridFour({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.125 4.125H4.875C4.46079 4.125 4.125 4.46079 4.125 4.875V19.125C4.125 19.5392 4.46079 19.875 4.875 19.875H19.125C19.5392 19.875 19.875 19.5392 19.875 19.125V4.875C19.875 4.46079 19.5392 4.125 19.125 4.125Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 4.125V19.875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.875 12H4.125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UserIconRecruit({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NounListIcon() {
  return (
    <svg
      width="146"
      height="146"
      viewBox="0 0 146 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M96.0742 31.678C95.9935 31.5509 95.9006 31.4312 95.7971 31.322L79.1327 14.6225C79.0219 14.5109 78.8834 14.4302 78.7318 14.3903C78.705 14.3585 78.6634 14.3439 78.6227 14.3504C78.5086 14.3015 78.3856 14.273 78.2617 14.2665C78.2406 14.2445 78.212 14.2306 78.1827 14.2266H31.4398C30.6992 14.2347 30.1012 14.8327 30.0938 15.5725V101.227C30.0898 101.585 30.2307 101.929 30.4833 102.182C30.7367 102.436 31.0813 102.577 31.4398 102.572H94.8538C95.2123 102.577 95.5561 102.436 95.8095 102.182C96.0629 101.929 96.2038 101.585 96.1998 101.227V32.1977C96.1549 32.0397 96.1549 31.9655 96.1158 31.8417V31.8409C96.0971 31.7879 96.0841 31.7333 96.0759 31.6779L96.0742 31.678ZM79.4885 18.8134L91.6011 30.9357H79.4885V18.8134ZM93.506 99.8809H32.745V16.9174H76.837V32.2808C76.8516 33.0108 77.4529 33.5917 78.1829 33.5819H93.5064L93.506 99.8809ZM113.773 17.8685C113.776 16.9023 113.393 15.9743 112.709 15.2908C112.026 14.6073 111.098 14.2243 110.132 14.2267H108.034C107.066 14.2243 106.139 14.6072 105.456 15.2908C104.772 15.9743 104.389 16.9023 104.392 17.8685V23.2075C104.34 23.2361 104.296 23.2792 104.268 23.3314C102.971 24.5861 102.242 26.3158 102.249 28.1204V82.276C102.249 84.0472 103.912 94.4578 107.756 96.5158V101.227H107.756C107.751 101.582 107.888 101.924 108.138 102.177C108.387 102.43 108.727 102.572 109.082 102.572C109.437 102.572 109.778 102.43 110.027 102.177C110.276 101.924 110.413 101.582 110.408 101.227V96.5158C114.243 94.4577 115.905 84.0471 115.905 82.276V28.1204C115.901 26.2595 115.13 24.4819 113.773 23.2075L113.773 17.8685ZM107.084 17.8685C107.088 17.3463 107.511 16.9243 108.034 16.9185H110.132C110.384 16.9161 110.627 17.0155 110.806 17.1939C110.985 17.3723 111.084 17.6159 111.082 17.8685V21.6293C110.436 21.446 109.772 21.3392 109.103 21.3124C108.417 21.3148 107.736 21.4215 107.084 21.6293L107.084 17.8685ZM109.103 94.2244C107.99 94.2244 106.055 89.1576 105.258 85.1199H112.897C112.11 89.1585 110.166 94.2244 109.103 94.2244ZM113.214 82.2756V82.4687H104.941V47.8667H113.214V82.2756ZM113.214 45.1749H104.941V28.1186C104.942 27.0195 105.384 25.9661 106.168 25.1944C106.939 24.409 108.002 23.978 109.102 24.0024C110.191 24.0098 111.233 24.4465 112.003 25.2164C112.772 25.9871 113.207 27.03 113.214 28.1185L113.214 45.1749ZM44.4977 28.2422C44.1425 28.2455 43.8011 28.1062 43.5494 27.8561C43.2976 27.6067 43.1558 27.2662 43.1558 26.9118C43.1558 26.5566 43.2976 26.2168 43.5494 25.9667C43.8011 25.7166 44.1425 25.5781 44.4977 25.5805H64.725C65.0802 25.5764 65.4232 25.7149 65.6758 25.9651C65.9283 26.2152 66.0709 26.5558 66.0709 26.9118C66.0709 27.267 65.9283 27.6084 65.6758 27.8585C65.4232 28.1078 65.0802 28.2464 64.725 28.2423L44.4977 28.2422ZM59.2224 37.619H82.1423C82.8691 37.6271 83.4541 38.2186 83.4541 38.9446C83.4541 39.6713 82.8691 40.2628 82.1423 40.271H59.2224C58.868 40.2767 58.525 40.139 58.2725 39.8897C58.0191 39.6404 57.8765 39.2998 57.8765 38.9446C57.8765 38.5902 58.0191 38.2496 58.2725 38.0003C58.525 37.751 58.868 37.6133 59.2224 37.619V37.619ZM44.4977 52.3445C43.7563 52.3405 43.1575 51.7392 43.1575 50.9986C43.1575 50.2572 43.7563 49.6559 44.4977 49.6527H78.1027C78.4604 49.6519 78.8042 49.7928 79.0568 50.0454C79.3102 50.2979 79.4527 50.641 79.4527 50.9986C79.4527 51.3555 79.3102 51.6985 79.0568 51.951C78.8042 52.2036 78.4604 52.3454 78.1027 52.3445H44.4977ZM82.1407 61.6911C82.8682 61.7155 83.4467 62.3094 83.4516 63.037C83.4565 63.7686 82.8723 64.3683 82.1407 64.3821H59.2208C58.8631 64.3845 58.5201 64.2436 58.2667 63.991C58.0142 63.7377 57.8732 63.3938 57.8748 63.037C57.8813 62.2956 58.4802 61.6967 59.2208 61.6911H82.1407ZM44.4977 76.4108C44.1433 76.4148 43.8019 76.2772 43.5502 76.0279C43.2984 75.7785 43.1567 75.4388 43.1567 75.0852C43.1567 74.7308 43.2984 74.3911 43.5502 74.1418C43.8019 73.8933 44.1433 73.7548 44.4977 73.7589H71.4138C71.7682 73.754 72.1113 73.8908 72.3638 74.1401C72.6172 74.3894 72.759 74.73 72.759 75.0852C72.759 75.4404 72.6172 75.7802 72.3638 76.0295C72.1113 76.2788 71.7682 76.4165 71.4138 76.4108H44.4977ZM82.1407 85.7923C82.4935 85.7964 82.8291 85.9406 83.0752 86.1932C83.3212 86.4457 83.4573 86.7855 83.4524 87.1382C83.4467 87.8658 82.8682 88.4597 82.1407 88.4842H59.2208C58.4802 88.4777 57.8813 87.8788 57.8748 87.1382C57.8708 86.7797 58.0109 86.4343 58.2643 86.1809C58.5176 85.9276 58.8631 85.7874 59.2208 85.7923H82.1407ZM52.5319 44.3095C53.2635 44.2981 53.8485 43.6961 53.8379 42.9636V34.928C53.8346 34.2012 53.2578 33.6073 52.5319 33.582H44.4962C43.7573 33.5902 43.1609 34.189 43.1552 34.928V42.9636C43.1511 43.3205 43.2904 43.6651 43.543 43.9177C43.7956 44.171 44.1386 44.312 44.4962 44.3095H52.5319ZM45.8422 36.2739H51.186V41.6177H45.8422V36.2739ZM52.5319 68.421C53.2562 68.3925 53.8314 67.8002 53.8379 67.0751V59.0297C53.8452 58.2988 53.2619 57.6984 52.5319 57.6837H44.4962C44.1394 57.6829 43.7964 57.8247 43.5446 58.0772C43.2929 58.3298 43.1528 58.6728 43.1552 59.0297V67.0751C43.1642 67.8132 43.7581 68.4096 44.4962 68.421H52.5319ZM45.8422 60.3756H51.186V65.7292H45.8422V60.3756ZM44.4962 81.7959C44.1386 81.7926 43.7955 81.9344 43.543 82.187C43.2904 82.4403 43.1511 82.7842 43.1552 83.1418V91.1326C43.1503 91.4902 43.2896 91.8341 43.5422 92.0875C43.7947 92.3408 44.1386 92.4818 44.4962 92.4785H52.5319H52.531C52.883 92.4736 53.2187 92.3294 53.4639 92.0769C53.7092 91.8243 53.8436 91.4846 53.8379 91.1326V83.1418C53.8485 82.4094 53.2635 81.8073 52.5319 81.7959H44.4962ZM51.1859 89.8315H45.8421V84.4479H51.1859V89.8315Z"
        fill="#2F7BF5"
      />
    </svg>
  );
}

export function CurrencyInr() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.1875 6.875H17.1875"
        stroke="#403E3E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.1875 3.4375H17.1875"
        stroke="#403E3E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.28125 3.4375C10.4664 3.4375 11.6031 3.90831 12.4411 4.74637C13.2792 5.58442 13.75 6.72106 13.75 7.90625C13.75 9.09144 13.2792 10.2281 12.4411 11.0661C11.6031 11.9042 10.4664 12.375 9.28125 12.375H6.1875L13.75 19.25"
        stroke="#403E3E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DownloadOutlinedIcon({ color }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 13.75L16 19L21.25 13.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 5V19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 19V26C27 26.2652 26.8946 26.5196 26.7071 26.7071C26.5196 26.8946 26.2652 27 26 27H6C5.73478 27 5.48043 26.8946 5.29289 26.7071C5.10536 26.5196 5 26.2652 5 26V19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CopyIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5625 15.8125V3.4375H6.1875"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8125 6.1875H3.4375V18.5625H15.8125V6.1875Z"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Tags({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.503 2.42804L3.93741 3.93741L2.42804 11.503C2.40439 11.6238 2.41083 11.7486 2.4468 11.8663C2.48277 11.984 2.54716 12.0911 2.63429 12.178L12.4218 21.9655C12.4908 22.0361 12.5732 22.0922 12.6641 22.1305C12.7551 22.1688 12.8528 22.1885 12.9515 22.1885C13.0502 22.1885 13.1479 22.1688 13.2388 22.1305C13.3298 22.0922 13.4122 22.0361 13.4812 21.9655L21.9655 13.4812C22.0361 13.4122 22.0922 13.3298 22.1305 13.2388C22.1688 13.1479 22.1885 13.0502 22.1885 12.9515C22.1885 12.8528 22.1688 12.7551 22.1305 12.6641C22.0922 12.5732 22.0361 12.4908 21.9655 12.4218L12.178 2.63429C12.0911 2.54716 11.984 2.48277 11.8663 2.4468C11.7486 2.41083 11.6238 2.40439 11.503 2.42804V2.42804Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.875 9C8.49632 9 9 8.49632 9 7.875C9 7.25368 8.49632 6.75 7.875 6.75C7.25368 6.75 6.75 7.25368 6.75 7.875C6.75 8.49632 7.25368 9 7.875 9Z"
        fill="#2F7BF5"
      />
    </svg>
  );
}

export function Student({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6V13.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.08154 20.2504C5.83198 19.0994 6.85771 18.1538 8.06582 17.4993C9.27394 16.8447 10.6263 16.502 12.0003 16.502C13.3743 16.502 14.7266 16.8447 15.9348 17.4993C17.1429 18.1538 18.1686 19.0994 18.919 20.2504"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 6L12 9L3 6L12 3L21 6Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8719 7.70508C16.5599 8.45637 17.0144 9.39159 17.1801 10.3967C17.3458 11.4019 17.2155 12.4335 16.805 13.3659C16.3946 14.2982 15.7218 15.091 14.8686 15.6477C14.0154 16.2043 13.0187 16.5007 12 16.5007C10.9813 16.5007 9.9846 16.2043 9.13141 15.6477C8.27822 15.091 7.6054 14.2982 7.19497 13.3659C6.78453 12.4335 6.65422 11.4019 6.81991 10.3967C6.98561 9.39159 7.44015 8.45637 8.12813 7.70508"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FilePlus({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H14.25L19.5 8.25V20.25C19.5 20.4489 19.421 20.6397 19.2803 20.7803C19.1397 20.921 18.9489 21 18.75 21Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 3V8.25H19.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 14.25H14.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12V16.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CalendarCheckIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 2.25V5.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 2.25V5.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 8.25H20.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.375 12L10.9969 16.125L8.625 13.875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DisableUserIcon({ color }) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L21.72 23.803"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z"
        stroke={color}
        strokeWidth="2"
        stroke-miterlimit="10"
      />
      <path
        d="M2.90625 21.2499C3.82775 19.6534 5.15328 18.3277 6.74958 17.406C8.34588 16.4843 10.1567 15.999 12 15.999C13.8433 15.999 15.6541 16.4843 17.2504 17.406C18.8467 18.3277 20.1722 19.6534 21.0938 21.2499"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MultipleUserIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z"
        stroke="#403E3E"
        strokeWidth="2"
        stroke-miterlimit="10"
      />
      <path
        d="M14.5688 5.42813C14.9998 5.31124 15.4442 5.25136 15.8907 5.25C17.1837 5.25 18.4236 5.76361 19.3379 6.67785C20.2521 7.59209 20.7657 8.83207 20.7657 10.125C20.7657 11.4179 20.2521 12.6579 19.3379 13.5721C18.4236 14.4864 17.1837 15 15.8907 15"
        stroke="#403E3E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 18.5066C2.2612 17.4234 3.27191 16.5393 4.44676 15.9289C5.6216 15.3186 6.92608 15 8.25 15C9.57392 15 10.8784 15.3186 12.0532 15.9289C13.2281 16.5393 14.2388 17.4234 15 18.5066"
        stroke="#403E3E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8906 15C17.2147 14.9992 18.5194 15.3174 19.6944 15.9277C20.8693 16.5381 21.8799 17.4225 22.6406 18.5063"
        stroke="#403E3E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ListBulletsIcon({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.875 5H16.875"
        stroke={color}
        strokeOpacity="0.6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 10H16.875"
        stroke={color}
        strokeOpacity="0.6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M6.875 15H16.875"
        stroke={color}
        strokeOpacity="0.6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M3.4375 5.9375C3.95527 5.9375 4.375 5.51777 4.375 5C4.375 4.48223 3.95527 4.0625 3.4375 4.0625C2.91973 4.0625 2.5 4.48223 2.5 5C2.5 5.51777 2.91973 5.9375 3.4375 5.9375Z"
        fill={color}
        fillOpacity="0.6"
      />

      <path
        d="M3.4375 10.9375C3.95527 10.9375 4.375 10.5178 4.375 10C4.375 9.48223 3.95527 9.0625 3.4375 9.0625C2.91973 9.0625 2.5 9.48223 2.5 10C2.5 10.5178 2.91973 10.9375 3.4375 10.9375Z"
        fill={color}
        fillOpacity="0.6"
      />

      <path
        d="M3.4375 15.9375C3.95527 15.9375 4.375 15.5178 4.375 15C4.375 14.4822 3.95527 14.0625 3.4375 14.0625C2.91973 14.0625 2.5 14.4822 2.5 15C2.5 15.5178 2.91973 15.9375 3.4375 15.9375Z"
        fill={color}
        fillOpacity="0.6"
      />
    </svg>
  );
}

export function DownLoadIcon({ color }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 13.75L16 19L21.25 13.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 5V19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 19V26C27 26.2652 26.8946 26.5196 26.7071 26.7071C26.5196 26.8946 26.2652 27 26 27H6C5.73478 27 5.48043 26.8946 5.29289 26.7071C5.10536 26.5196 5 26.2652 5 26V19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function MinusIcons({ color }) {
  return (
    <svg
      width="10"
      height="2"
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 1H8.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function GroupIcon({ color }) {
  return (
    <svg
      width="73"
      height="88"
      viewBox="0 0 73 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7142 87.5387H37.5513C38.439 87.5387 39.1588 86.7548 39.1588 85.7879C39.1588 84.8211 38.439 84.0371 37.5513 84.0371H17.7142C9.70921 84.0371 3.21467 78.2244 3.21467 71.0462V20.0294H20.1254C20.5517 20.0294 20.9608 19.8449 21.2621 19.5166C21.5635 19.1876 21.7329 18.7428 21.7329 18.2786V3.50156H49.9288C57.9339 3.50156 64.4607 9.31436 64.4607 16.4926V44.7852H64.46C64.46 45.2495 64.6294 45.695 64.9308 46.0233C65.2322 46.3515 65.6412 46.536 66.0675 46.536C66.4938 46.536 66.9028 46.3515 67.2042 46.0233C67.5056 45.695 67.675 45.2495 67.675 44.7852V16.4926C67.675 7.3885 59.7023 0 49.9281 0H19.6434C19.38 0.0343914 19.1332 0.157102 18.9358 0.350156L1.28598 16.5972C0.537501 16.7637 0 17.4812 0 18.3128V71.0464C0 80.1505 7.94127 87.539 17.7145 87.539L17.7142 87.5387ZM18.3572 16.527H6.33353L18.3572 5.49706V16.527Z"
        fill={color}
      />
      <path
        d="M16.5235 36.3473H50.9564C51.3826 36.3473 51.7917 36.1628 52.0931 35.8345C52.3945 35.5063 52.5638 35.0608 52.5638 34.5965C52.5638 34.1322 52.3945 33.6875 52.0931 33.3584C51.7917 33.0302 51.3826 32.8457 50.9564 32.8457H16.5235C15.6358 32.8457 14.916 33.6297 14.916 34.5965C14.916 35.0608 15.0854 35.5063 15.3868 35.8345C15.6889 36.1628 16.0972 36.3473 16.5235 36.3473V36.3473Z"
        fill={color}
      />
      <path
        d="M41.9858 47.5164C41.9858 47.0521 41.8164 46.6066 41.515 46.2784C41.2136 45.9501 40.8046 45.7656 40.3783 45.7656H16.5235C15.6358 45.7656 14.916 46.5488 14.916 47.5164C14.916 48.4832 15.6358 49.2672 16.5235 49.2672H40.3783C40.8046 49.2672 41.2136 49.0827 41.515 48.7545C41.8164 48.4254 41.9858 47.9807 41.9858 47.5164Z"
        fill={color}
      />
      <path
        d="M16.5235 58.707C15.6358 58.707 14.916 59.4902 14.916 60.4578C14.916 60.9221 15.0854 61.3668 15.3868 61.6959C15.6889 62.0241 16.0972 62.2086 16.5235 62.2086H30.5408C31.4213 62.1898 32.131 61.4168 32.1483 60.4578C32.1483 59.9935 31.9789 59.548 31.6775 59.2198C31.3761 58.8915 30.9671 58.707 30.5408 58.707H16.5235Z"
        fill={color}
      />
      <path
        d="M54.7178 87.5357C59.4074 87.5357 63.9048 85.5066 67.221 81.895C70.5371 78.2832 72.3999 73.385 72.3999 68.2772C72.3999 63.1693 70.5369 58.2711 67.221 54.6593C63.9048 51.0475 59.4076 49.0186 54.7178 49.0186C50.0282 49.0186 45.5308 51.0477 42.2146 54.6593C38.8985 58.2711 37.0356 63.1693 37.0356 68.2772C37.0356 73.385 38.8987 78.2832 42.2146 81.895C45.5308 85.5068 50.028 87.5357 54.7178 87.5357V87.5357ZM54.7178 52.5201C58.555 52.5201 62.2341 54.1802 64.9475 57.1354C67.6609 60.0899 69.185 64.0979 69.185 68.2772C69.185 72.4564 67.6608 76.4644 64.9475 79.4189C62.2341 82.3742 58.555 84.0342 54.7178 84.0342C50.8806 84.0342 47.2007 82.3741 44.4881 79.4189C41.7746 76.4644 40.2506 72.4564 40.2506 68.2772C40.2506 64.0979 41.7748 60.0899 44.4881 57.1354C47.2007 54.1801 50.8806 52.5201 54.7178 52.5201V52.5201Z"
        fill={color}
      />
      <path
        d="M47.6783 70.0194H53.1113V75.9368C53.1113 76.4011 53.2807 76.8466 53.5821 77.1749C53.8835 77.5032 54.2925 77.6876 54.7188 77.6876C55.1451 77.6876 55.5541 77.5032 55.8555 77.1749C56.1569 76.8466 56.3263 76.4011 56.3263 75.9368V70.0194H61.9201C62.8078 70.0194 63.5275 69.2354 63.5275 68.2686C63.5275 67.3018 62.8078 66.5178 61.9201 66.5178H56.3263V60.6004C56.3263 60.1361 56.1569 59.6906 55.8555 59.3623C55.5541 59.0341 55.1451 58.8496 54.7188 58.8496C53.8311 58.8496 53.1113 59.6336 53.1113 60.6004V66.5178H47.6783C46.7899 66.5178 46.0708 67.3018 46.0708 68.2686C46.0708 69.2354 46.7899 70.0194 47.6783 70.0194Z"
        fill={color}
      />
    </svg>
  );
}

export function BankIcon() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="#E3EBFF" />
      <path
        d="M15.25 22H34.75L25 16L15.25 22Z"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.25 22V29.5"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.75 22V29.5"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.25 22V29.5"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.75 22V29.5"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 29.5H34"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 32.5H35.5"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Credentials() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="#E3EBFF" />
      <path
        d="M13 13V12H12V13H13ZM37 13H38V12H37V13ZM37 37V38H38V37H37ZM13 37H12V38H13V37ZM27.25 22.5C26.6977 22.5 26.25 22.9477 26.25 23.5C26.25 24.0523 26.6977 24.5 27.25 24.5V22.5ZM31 24.5C31.5523 24.5 32 24.0523 32 23.5C32 22.9477 31.5523 22.5 31 22.5V24.5ZM27.25 25.5C26.6977 25.5 26.25 25.9477 26.25 26.5C26.25 27.0523 26.6977 27.5 27.25 27.5V25.5ZM31 27.5C31.5523 27.5 32 27.0523 32 26.5C32 25.9477 31.5523 25.5 31 25.5V27.5ZM17.7613 28.5003C17.6243 29.0354 17.9469 29.5801 18.482 29.7171C19.017 29.8541 19.5618 29.5314 19.6988 28.9964L17.7613 28.5003ZM23.5737 28.9964C23.7107 29.5314 24.2555 29.8541 24.7905 29.7171C25.3256 29.5801 25.6482 29.0354 25.5112 28.5003L23.5737 28.9964ZM13 14H37V12H13V14ZM36 13V37H38V13H36ZM37 36H13V38H37V36ZM14 37V13H12V37H14ZM27.25 24.5H31V22.5H27.25V24.5ZM27.25 27.5H31V25.5H27.25V27.5ZM22.8862 24.25C22.8862 24.9404 22.3266 25.5 21.6362 25.5V27.5C23.4312 27.5 24.8862 26.0449 24.8862 24.25H22.8862ZM21.6362 25.5C20.9459 25.5 20.3863 24.9404 20.3863 24.25H18.3863C18.3863 26.0449 19.8413 27.5 21.6362 27.5V25.5ZM20.3863 24.25C20.3863 23.5596 20.9459 23 21.6362 23V21C19.8413 21 18.3863 22.4551 18.3863 24.25H20.3863ZM21.6362 23C22.3266 23 22.8862 23.5596 22.8862 24.25H24.8862C24.8862 22.4551 23.4312 21 21.6362 21V23ZM19.6988 28.9964C19.8089 28.5662 20.0591 28.1849 20.4099 27.9126L19.1836 26.3327C18.482 26.8773 17.9816 27.6399 17.7613 28.5003L19.6988 28.9964ZM20.4099 27.9126C20.7607 27.6403 21.1922 27.4925 21.6362 27.4925V25.4925C20.7481 25.4925 19.8852 25.7881 19.1836 26.3327L20.4099 27.9126ZM21.6362 27.4925C22.0803 27.4925 22.5118 27.6403 22.8626 27.9126L24.0889 26.3327C23.3873 25.7881 22.5244 25.4925 21.6362 25.4925V27.4925ZM22.8626 27.9126C23.2134 28.1849 23.4636 28.5662 23.5737 28.9964L25.5112 28.5003C25.2909 27.6399 24.7905 26.8773 24.0889 26.3327L22.8626 27.9126ZM16.75 18.5H33.25V16.5H16.75V18.5ZM33.25 18.5C33.1119 18.5 33 18.3881 33 18.25H35C35 17.2835 34.2165 16.5 33.25 16.5V18.5ZM33 18.25V31.75H35V18.25H33ZM33 31.75C33 31.6119 33.1119 31.5 33.25 31.5V33.5C34.2165 33.5 35 32.7165 35 31.75H33ZM33.25 31.5H16.75V33.5H33.25V31.5ZM16.75 31.5C16.8881 31.5 17 31.6119 17 31.75H15C15 32.7165 15.7835 33.5 16.75 33.5V31.5ZM17 31.75V18.25H15V31.75H17ZM17 18.25C17 18.3881 16.8881 18.5 16.75 18.5V16.5C15.7835 16.5 15 17.2835 15 18.25H17Z"
        fill="#2F7BF5"
      />
    </svg>
  );
}
export function TagsIcon({ color }) {
  return (
    <svg
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.8252 53.0254V45.4504H35.3503V53.0254H42.9253V55.5504H35.3503V63.1255H32.8252V55.5504H25.2502V53.0254H32.8252ZM27.1215 42.2716C22.9828 44.6754 20.2002 49.1574 20.2002 54.2879C20.2002 61.9588 26.4169 68.1755 34.0877 68.1755C39.2184 68.1755 43.7002 65.3929 46.1041 61.2542L53.9874 69.1376C55.9669 71.1171 59.1687 71.1221 61.1358 69.1579L79.2582 51.0355C81.2274 49.0663 81.2173 45.8666 79.2379 43.8871L45.4503 10.0996H25.2503C22.4627 10.0996 20.2003 12.3394 20.2003 15.1496V35.3497L27.1215 42.2716ZM29.7045 41.1049L22.7252 34.0879V15.1705C22.7252 13.7795 23.8665 12.6251 25.2706 12.6251H44.1879L77.4228 45.5873C78.4103 46.5669 78.4154 48.1552 77.4381 49.1398L59.3489 67.3531C58.3744 68.3355 56.7833 68.3355 55.8038 67.348L47.2463 58.7455C47.7186 57.3466 47.9762 55.8491 47.9762 54.2912C47.9762 46.6204 41.7595 40.4037 34.0886 40.4037C32.5585 40.4037 31.084 40.6511 29.7054 41.1082L29.7045 41.1049ZM34.0877 30.3003C30.6006 30.3003 27.7752 27.4749 27.7752 23.9878C27.7752 20.5007 30.6006 17.6753 34.0877 17.6753C37.5749 17.6753 40.4003 20.5007 40.4003 23.9878C40.4003 27.4749 37.5749 30.3003 34.0877 30.3003V30.3003ZM34.0877 27.7753C36.1782 27.7753 37.8753 26.0782 37.8753 23.9878C37.8753 21.8974 36.1782 20.2003 34.0877 20.2003C31.9973 20.2003 30.3002 21.8974 30.3002 23.9878C30.3002 26.0782 31.9973 27.7753 34.0877 27.7753V27.7753ZM34.0877 65.6505C27.813 65.6505 22.7252 60.5627 22.7252 54.2879C22.7252 48.0132 27.813 42.9254 34.0877 42.9254C40.3625 42.9254 45.4503 48.0132 45.4503 54.2879C45.4503 60.5627 40.3625 65.6505 34.0877 65.6505V65.6505Z"
        fill={color}
      />
    </svg>
  );
}
export function SunIcon({ color }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 19.0938C16.3655 19.0938 19.0938 16.3655 19.0938 13C19.0938 9.63451 16.3655 6.90625 13 6.90625C9.63451 6.90625 6.90625 9.63451 6.90625 13C6.90625 16.3655 9.63451 19.0938 13 19.0938Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 3.65625V1.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38418 6.38906L4.95215 4.95703"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.65625 13H1.625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38418 19.6138L4.95215 21.0458"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 22.3438V24.375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6128 19.6138L21.0448 21.0458"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3438 13H24.375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6128 6.38906L21.0448 4.95703"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function MoonIcon({ color }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0091 15.4992C20.4139 15.9465 18.7284 15.9612 17.1257 15.5417C15.5229 15.1222 14.0607 14.2836 12.8892 13.1121C11.7177 11.9406 10.8792 10.4784 10.4596 8.87568C10.0401 7.27293 10.0548 5.5874 10.5021 3.99219C8.92938 4.42993 7.49879 5.2721 6.35282 6.4348C5.20686 7.5975 4.38552 9.04015 3.97062 10.6191C3.55572 12.198 3.56173 13.858 3.98807 15.4339C4.4144 17.0098 5.24618 18.4464 6.40054 19.6008C7.5549 20.7552 8.99156 21.5869 10.5674 22.0133C12.1433 22.4396 13.8034 22.4456 15.3823 22.0307C16.9612 21.6158 18.4038 20.7945 19.5665 19.6485C20.7292 18.5025 21.5714 17.072 22.0091 15.4992V15.4992Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AgreedCommercialIcon({ color }) {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="#E3EBFF" />
      <path
        d="M21.5 20.5H28.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 24H28.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 27.5H25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1391 33.625H16.25C16.0179 33.625 15.7954 33.5328 15.6313 33.3687C15.4672 33.2046 15.375 32.9821 15.375 32.75V15.25C15.375 15.0179 15.4672 14.7954 15.6313 14.6313C15.7954 14.4672 16.0179 14.375 16.25 14.375H33.75C33.9821 14.375 34.2046 14.4672 34.3687 14.6313C34.5328 14.7954 34.625 15.0179 34.625 15.25V27.1391C34.6254 27.2527 34.6034 27.3653 34.5602 27.4704C34.5171 27.5755 34.4536 27.671 34.3734 27.7516L28.7516 33.3734C28.671 33.4536 28.5755 33.5171 28.4704 33.5602C28.3653 33.6034 28.2527 33.6254 28.1391 33.625V33.625Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5484 27.5H28.5V33.5484"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UserIconForRequirement({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z"
        stroke={color}
        strokeWidth="2"
        stroke-miterlimit="10"
      />
      <path
        d="M2.90625 20.2499C3.82775 18.6534 5.15328 17.3277 6.74958 16.406C8.34588 15.4843 10.1567 14.999 12 14.999C13.8433 14.999 15.6541 15.4843 17.2504 16.406C18.8467 17.3277 20.1722 18.6534 21.0938 20.2499"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Premium() {
  return (
    <svg
      width="52"
      height="20"
      viewBox="0 0 52 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="52" height="20" rx="10" fill="#F9DE9A" />
      <path
        d="M6.72 13V5.84H9.2C9.52 5.84 9.82 5.89333 10.1 6C10.3867 6.10667 10.6367 6.25667 10.85 6.45C11.0633 6.64333 11.23 6.87667 11.35 7.15C11.4767 7.41667 11.54 7.71333 11.54 8.04C11.54 8.36 11.4767 8.65667 11.35 8.93C11.23 9.19667 11.0633 9.42667 10.85 9.62C10.6367 9.81333 10.3867 9.96333 10.1 10.07C9.82 10.1767 9.52 10.23 9.2 10.23H7.85V13H6.72ZM9.23 9.15C9.41667 9.15 9.58333 9.12 9.73 9.06C9.87667 8.99333 10 8.90667 10.1 8.8C10.2 8.69333 10.2767 8.57333 10.33 8.44C10.3833 8.30667 10.41 8.17333 10.41 8.04C10.41 7.9 10.3833 7.76333 10.33 7.63C10.2767 7.49667 10.2 7.38 10.1 7.28C10 7.17333 9.87667 7.08667 9.73 7.02C9.58333 6.95333 9.41667 6.92 9.23 6.92H7.85V9.15H9.23ZM12.3413 8.1H13.3913V8.84H13.4513C13.5113 8.71333 13.5913 8.59667 13.6913 8.49C13.7979 8.37667 13.9146 8.28333 14.0413 8.21C14.1746 8.13 14.3113 8.07 14.4513 8.03C14.5979 7.98333 14.7379 7.96 14.8713 7.96C15.0313 7.96 15.1679 7.97333 15.2813 8C15.3946 8.02667 15.4979 8.06333 15.5913 8.11L15.2713 9.14C15.1979 9.10667 15.1146 9.08333 15.0213 9.07C14.9346 9.05 14.8279 9.04 14.7013 9.04C14.5213 9.04 14.3546 9.07667 14.2013 9.15C14.0546 9.22333 13.9246 9.32333 13.8113 9.45C13.6979 9.57667 13.6079 9.72667 13.5413 9.9C13.4813 10.0733 13.4513 10.2567 13.4513 10.45V13H12.3413V8.1ZM20.4262 11.83C20.2195 12.21 19.9262 12.5267 19.5462 12.78C19.1662 13.0333 18.6995 13.16 18.1462 13.16C17.7795 13.16 17.4395 13.0967 17.1262 12.97C16.8195 12.8367 16.5528 12.6533 16.3262 12.42C16.0995 12.1867 15.9228 11.9133 15.7962 11.6C15.6695 11.28 15.6062 10.93 15.6062 10.55C15.6062 10.1967 15.6662 9.86333 15.7862 9.55C15.9062 9.23 16.0728 8.95333 16.2862 8.72C16.5062 8.48 16.7695 8.29 17.0762 8.15C17.3828 8.01 17.7228 7.94 18.0962 7.94C18.4762 7.94 18.8128 8.00333 19.1062 8.13C19.4062 8.25667 19.6595 8.43333 19.8662 8.66C20.0728 8.88667 20.2295 9.16 20.3362 9.48C20.4495 9.8 20.5062 10.15 20.5062 10.53C20.5062 10.5633 20.5062 10.5933 20.5062 10.62C20.4995 10.6533 20.4962 10.6833 20.4962 10.71C20.4895 10.7367 20.4862 10.7633 20.4862 10.79H16.7162C16.7362 11.0233 16.7928 11.2267 16.8862 11.4C16.9795 11.5733 17.0928 11.7167 17.2262 11.83C17.3662 11.9433 17.5195 12.0267 17.6862 12.08C17.8528 12.1333 18.0162 12.16 18.1762 12.16C18.4962 12.16 18.7595 12.0833 18.9662 11.93C19.1728 11.7767 19.3428 11.5867 19.4762 11.36L20.4262 11.83ZM19.3962 9.94C19.3828 9.84 19.3495 9.73 19.2962 9.61C19.2495 9.48333 19.1728 9.37 19.0662 9.27C18.9662 9.16333 18.8328 9.07333 18.6662 9C18.5062 8.92667 18.3095 8.89 18.0762 8.89C17.7562 8.89 17.4795 8.98667 17.2462 9.18C17.0195 9.36667 16.8662 9.62 16.7862 9.94H19.3962ZM21.3452 8.1H22.3952V8.76H22.4552C22.6085 8.52 22.8218 8.32333 23.0952 8.17C23.3685 8.01667 23.6585 7.94 23.9652 7.94C24.3318 7.94 24.6452 8.02667 24.9052 8.2C25.1718 8.36667 25.3652 8.58667 25.4852 8.86C25.6518 8.6 25.8752 8.38333 26.1552 8.21C26.4352 8.03 26.7718 7.94 27.1652 7.94C27.4652 7.94 27.7252 7.99 27.9452 8.09C28.1652 8.18333 28.3452 8.31667 28.4852 8.49C28.6318 8.66333 28.7418 8.87333 28.8152 9.12C28.8885 9.36 28.9252 9.63 28.9252 9.93V13H27.8152V10.12C27.8152 9.69333 27.7318 9.39667 27.5652 9.23C27.4052 9.05667 27.1685 8.97 26.8552 8.97C26.6752 8.97 26.5118 9.01 26.3652 9.09C26.2252 9.17 26.1052 9.28 26.0052 9.42C25.9052 9.55333 25.8285 9.71 25.7752 9.89C25.7218 10.07 25.6952 10.26 25.6952 10.46V13H24.5852V10.12C24.5852 9.69333 24.4985 9.39667 24.3252 9.23C24.1585 9.05667 23.9152 8.97 23.5952 8.97C23.4218 8.97 23.2652 9.01 23.1252 9.09C22.9852 9.17 22.8652 9.28 22.7652 9.42C22.6652 9.55333 22.5885 9.71 22.5352 9.89C22.4818 10.07 22.4552 10.26 22.4552 10.46V13H21.3452V8.1ZM30.6473 7.23C30.4339 7.23 30.2539 7.15667 30.1073 7.01C29.9673 6.86333 29.8973 6.68667 29.8973 6.48C29.8973 6.27333 29.9673 6.09667 30.1073 5.95C30.2539 5.80333 30.4339 5.73 30.6473 5.73C30.8539 5.73 31.0273 5.80333 31.1673 5.95C31.3139 6.09667 31.3873 6.27333 31.3873 6.48C31.3873 6.68667 31.3139 6.86333 31.1673 7.01C31.0273 7.15667 30.8539 7.23 30.6473 7.23ZM30.0873 13V8.1H31.1973V13H30.0873ZM35.8098 12.34H35.7498C35.6032 12.5733 35.3932 12.77 35.1198 12.93C34.8532 13.0833 34.5498 13.16 34.2098 13.16C33.5898 13.16 33.1265 12.9767 32.8198 12.61C32.5132 12.2367 32.3598 11.7433 32.3598 11.13V8.1H33.4698V10.98C33.4698 11.4067 33.5665 11.7067 33.7598 11.88C33.9598 12.0467 34.2198 12.13 34.5398 12.13C34.7265 12.13 34.8932 12.09 35.0398 12.01C35.1932 11.93 35.3232 11.8233 35.4298 11.69C35.5365 11.55 35.6165 11.3933 35.6698 11.22C35.7232 11.04 35.7498 10.8533 35.7498 10.66V8.1H36.8598V13H35.8098V12.34ZM37.976 8.1H39.026V8.76H39.086C39.2393 8.52 39.4527 8.32333 39.726 8.17C39.9993 8.01667 40.2893 7.94 40.596 7.94C40.9627 7.94 41.276 8.02667 41.536 8.2C41.8027 8.36667 41.996 8.58667 42.116 8.86C42.2827 8.6 42.506 8.38333 42.786 8.21C43.066 8.03 43.4027 7.94 43.796 7.94C44.096 7.94 44.356 7.99 44.576 8.09C44.796 8.18333 44.976 8.31667 45.116 8.49C45.2627 8.66333 45.3727 8.87333 45.446 9.12C45.5193 9.36 45.556 9.63 45.556 9.93V13H44.446V10.12C44.446 9.69333 44.3627 9.39667 44.196 9.23C44.036 9.05667 43.7993 8.97 43.486 8.97C43.306 8.97 43.1427 9.01 42.996 9.09C42.856 9.17 42.736 9.28 42.636 9.42C42.536 9.55333 42.4593 9.71 42.406 9.89C42.3527 10.07 42.326 10.26 42.326 10.46V13H41.216V10.12C41.216 9.69333 41.1293 9.39667 40.956 9.23C40.7893 9.05667 40.546 8.97 40.226 8.97C40.0527 8.97 39.896 9.01 39.756 9.09C39.616 9.17 39.496 9.28 39.396 9.42C39.296 9.55333 39.2193 9.71 39.166 9.89C39.1127 10.07 39.086 10.26 39.086 10.46V13H37.976V8.1Z"
        fill="#B54405"
      />
    </svg>
  );
}

export function Hot() {
  return (
    <svg
      width="34"
      height="20"
      viewBox="0 0 34 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="34" height="20" rx="10" fill="#FCBEB0" />
      <path
        d="M9.72 6.84H10.85V9.81H14.16V6.84H15.29V14H14.16V10.87H10.85V14H9.72V6.84ZM18.8517 8.94C19.2251 8.94 19.5684 9.00667 19.8817 9.14C20.1951 9.26667 20.4651 9.44667 20.6917 9.68C20.9184 9.91333 21.0951 10.19 21.2217 10.51C21.3484 10.83 21.4117 11.1767 21.4117 11.55C21.4117 11.9233 21.3484 12.27 21.2217 12.59C21.0951 12.91 20.9184 13.1867 20.6917 13.42C20.4651 13.6533 20.1951 13.8367 19.8817 13.97C19.5684 14.0967 19.2251 14.16 18.8517 14.16C18.4784 14.16 18.1351 14.0967 17.8217 13.97C17.5084 13.8367 17.2384 13.6533 17.0117 13.42C16.7851 13.1867 16.6084 12.91 16.4817 12.59C16.3551 12.27 16.2917 11.9233 16.2917 11.55C16.2917 11.1767 16.3551 10.83 16.4817 10.51C16.6084 10.19 16.7851 9.91333 17.0117 9.68C17.2384 9.44667 17.5084 9.26667 17.8217 9.14C18.1351 9.00667 18.4784 8.94 18.8517 8.94ZM18.8517 13.13C19.0384 13.13 19.2184 13.0933 19.3917 13.02C19.5651 12.9467 19.7184 12.8433 19.8517 12.71C19.9917 12.5767 20.1017 12.4133 20.1817 12.22C20.2617 12.02 20.3017 11.7967 20.3017 11.55C20.3017 11.3033 20.2617 11.0833 20.1817 10.89C20.1017 10.69 19.9917 10.5233 19.8517 10.39C19.7184 10.2567 19.5651 10.1533 19.3917 10.08C19.2184 10.0067 19.0384 9.97 18.8517 9.97C18.6651 9.97 18.4851 10.0067 18.3117 10.08C18.1384 10.1533 17.9817 10.2567 17.8417 10.39C17.7084 10.5233 17.6017 10.69 17.5217 10.89C17.4417 11.0833 17.4017 11.3033 17.4017 11.55C17.4017 11.7967 17.4417 12.02 17.5217 12.22C17.6017 12.4133 17.7084 12.5767 17.8417 12.71C17.9817 12.8433 18.1384 12.9467 18.3117 13.02C18.4851 13.0933 18.6651 13.13 18.8517 13.13ZM22.6488 10.08H21.7888V9.1H22.6488V7.6H23.7588V9.1H24.9688V10.08H23.7588V12.26C23.7588 12.38 23.7722 12.49 23.7988 12.59C23.8255 12.69 23.8655 12.7733 23.9188 12.84C24.0322 12.9667 24.1755 13.03 24.3488 13.03C24.4555 13.03 24.5388 13.0233 24.5988 13.01C24.6588 12.99 24.7222 12.9633 24.7888 12.93L25.1288 13.91C24.9888 13.9633 24.8422 14.0033 24.6888 14.03C24.5355 14.0633 24.3622 14.08 24.1688 14.08C23.9355 14.08 23.7288 14.0433 23.5488 13.97C23.3688 13.8967 23.2122 13.7967 23.0788 13.67C22.7922 13.3833 22.6488 12.9933 22.6488 12.5V10.08Z"
        fill="#F83A3A"
      />
    </svg>
  );
}

export function Featured() {
  return (
    <svg
      width="52"
      height="20"
      viewBox="0 0 52 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="52" height="20" rx="10" fill="#D2EFCD" />
      <path
        d="M6.72 5.84H11.08V6.92H7.85V8.97H10.76V10.03H7.85V13H6.72V5.84ZM16.1977 11.83C15.991 12.21 15.6977 12.5267 15.3177 12.78C14.9377 13.0333 14.471 13.16 13.9177 13.16C13.551 13.16 13.211 13.0967 12.8977 12.97C12.591 12.8367 12.3243 12.6533 12.0977 12.42C11.871 12.1867 11.6943 11.9133 11.5677 11.6C11.441 11.28 11.3777 10.93 11.3777 10.55C11.3777 10.1967 11.4377 9.86333 11.5577 9.55C11.6777 9.23 11.8443 8.95333 12.0577 8.72C12.2777 8.48 12.541 8.29 12.8477 8.15C13.1543 8.01 13.4943 7.94 13.8677 7.94C14.2477 7.94 14.5843 8.00333 14.8777 8.13C15.1777 8.25667 15.431 8.43333 15.6377 8.66C15.8443 8.88667 16.001 9.16 16.1077 9.48C16.221 9.8 16.2777 10.15 16.2777 10.53C16.2777 10.5633 16.2777 10.5933 16.2777 10.62C16.271 10.6533 16.2677 10.6833 16.2677 10.71C16.261 10.7367 16.2577 10.7633 16.2577 10.79H12.4877C12.5077 11.0233 12.5643 11.2267 12.6577 11.4C12.751 11.5733 12.8643 11.7167 12.9977 11.83C13.1377 11.9433 13.291 12.0267 13.4577 12.08C13.6243 12.1333 13.7877 12.16 13.9477 12.16C14.2677 12.16 14.531 12.0833 14.7377 11.93C14.9443 11.7767 15.1143 11.5867 15.2477 11.36L16.1977 11.83ZM15.1677 9.94C15.1543 9.84 15.121 9.73 15.0677 9.61C15.021 9.48333 14.9443 9.37 14.8377 9.27C14.7377 9.16333 14.6043 9.07333 14.4377 9C14.2777 8.92667 14.081 8.89 13.8477 8.89C13.5277 8.89 13.251 8.98667 13.0177 9.18C12.791 9.36667 12.6377 9.62 12.5577 9.94H15.1677ZM20.2655 12.4H20.2055C20.0588 12.5933 19.8688 12.77 19.6355 12.93C19.4021 13.0833 19.1055 13.16 18.7455 13.16C18.4855 13.16 18.2421 13.1167 18.0155 13.03C17.7888 12.95 17.5921 12.8367 17.4255 12.69C17.2588 12.5367 17.1255 12.36 17.0255 12.16C16.9321 11.9533 16.8855 11.7267 16.8855 11.48C16.8855 11.22 16.9355 10.9867 17.0355 10.78C17.1421 10.5733 17.2855 10.4 17.4655 10.26C17.6521 10.12 17.8721 10.0133 18.1255 9.94C18.3788 9.86 18.6521 9.82 18.9455 9.82C19.2721 9.82 19.5455 9.85333 19.7655 9.92C19.9855 9.98 20.1521 10.0367 20.2655 10.09V9.9C20.2655 9.75333 20.2321 9.61667 20.1655 9.49C20.1055 9.36333 20.0188 9.25667 19.9055 9.17C19.7988 9.07667 19.6755 9.00667 19.5355 8.96C19.3955 8.90667 19.2488 8.88 19.0955 8.88C18.8488 8.88 18.6255 8.93 18.4255 9.03C18.2321 9.12333 18.0588 9.27667 17.9055 9.49L17.0255 8.91C17.2588 8.59 17.5488 8.35 17.8955 8.19C18.2421 8.02333 18.6355 7.94 19.0755 7.94C19.8021 7.94 20.3621 8.12 20.7555 8.48C21.1555 8.84 21.3555 9.35333 21.3555 10.02V13H20.2655V12.4ZM20.2655 10.96C20.1188 10.8733 19.9555 10.8033 19.7755 10.75C19.5955 10.6967 19.3888 10.67 19.1555 10.67C18.8088 10.67 18.5321 10.75 18.3255 10.91C18.1188 11.07 18.0155 11.2633 18.0155 11.49C18.0155 11.61 18.0421 11.7167 18.0955 11.81C18.1488 11.8967 18.2155 11.9733 18.2955 12.04C18.3821 12.1067 18.4788 12.1567 18.5855 12.19C18.6988 12.2233 18.8121 12.24 18.9255 12.24C19.1055 12.24 19.2755 12.2067 19.4355 12.14C19.6021 12.0667 19.7455 11.9733 19.8655 11.86C19.9855 11.74 20.0821 11.6033 20.1555 11.45C20.2288 11.2967 20.2655 11.1333 20.2655 10.96ZM22.8422 9.08H21.9822V8.1H22.8422V6.6H23.9522V8.1H25.1622V9.08H23.9522V11.26C23.9522 11.38 23.9655 11.49 23.9922 11.59C24.0189 11.69 24.0589 11.7733 24.1122 11.84C24.2255 11.9667 24.3689 12.03 24.5422 12.03C24.6489 12.03 24.7322 12.0233 24.7922 12.01C24.8522 11.99 24.9155 11.9633 24.9822 11.93L25.3222 12.91C25.1822 12.9633 25.0355 13.0033 24.8822 13.03C24.7289 13.0633 24.5555 13.08 24.3622 13.08C24.1289 13.08 23.9222 13.0433 23.7422 12.97C23.5622 12.8967 23.4055 12.7967 23.2722 12.67C22.9855 12.3833 22.8422 11.9933 22.8422 11.5V9.08ZM29.4915 12.34H29.4315C29.2848 12.5733 29.0748 12.77 28.8015 12.93C28.5348 13.0833 28.2315 13.16 27.8915 13.16C27.2715 13.16 26.8082 12.9767 26.5015 12.61C26.1948 12.2367 26.0415 11.7433 26.0415 11.13V8.1H27.1515V10.98C27.1515 11.4067 27.2482 11.7067 27.4415 11.88C27.6415 12.0467 27.9015 12.13 28.2215 12.13C28.4082 12.13 28.5748 12.09 28.7215 12.01C28.8748 11.93 29.0048 11.8233 29.1115 11.69C29.2182 11.55 29.2982 11.3933 29.3515 11.22C29.4048 11.04 29.4315 10.8533 29.4315 10.66V8.1H30.5415V13H29.4915V12.34ZM31.6577 8.1H32.7077V8.84H32.7677C32.8277 8.71333 32.9077 8.59667 33.0077 8.49C33.1143 8.37667 33.231 8.28333 33.3577 8.21C33.491 8.13 33.6277 8.07 33.7677 8.03C33.9143 7.98333 34.0543 7.96 34.1877 7.96C34.3477 7.96 34.4843 7.97333 34.5977 8C34.711 8.02667 34.8143 8.06333 34.9077 8.11L34.5877 9.14C34.5143 9.10667 34.431 9.08333 34.3377 9.07C34.251 9.05 34.1443 9.04 34.0177 9.04C33.8377 9.04 33.671 9.07667 33.5177 9.15C33.371 9.22333 33.241 9.32333 33.1277 9.45C33.0143 9.57667 32.9243 9.72667 32.8577 9.9C32.7977 10.0733 32.7677 10.2567 32.7677 10.45V13H31.6577V8.1ZM39.7426 11.83C39.5359 12.21 39.2426 12.5267 38.8626 12.78C38.4826 13.0333 38.0159 13.16 37.4626 13.16C37.0959 13.16 36.7559 13.0967 36.4426 12.97C36.1359 12.8367 35.8692 12.6533 35.6426 12.42C35.4159 12.1867 35.2392 11.9133 35.1126 11.6C34.9859 11.28 34.9226 10.93 34.9226 10.55C34.9226 10.1967 34.9826 9.86333 35.1026 9.55C35.2226 9.23 35.3892 8.95333 35.6026 8.72C35.8226 8.48 36.0859 8.29 36.3926 8.15C36.6992 8.01 37.0392 7.94 37.4126 7.94C37.7926 7.94 38.1292 8.00333 38.4226 8.13C38.7226 8.25667 38.9759 8.43333 39.1826 8.66C39.3892 8.88667 39.5459 9.16 39.6526 9.48C39.7659 9.8 39.8226 10.15 39.8226 10.53C39.8226 10.5633 39.8226 10.5933 39.8226 10.62C39.8159 10.6533 39.8126 10.6833 39.8126 10.71C39.8059 10.7367 39.8026 10.7633 39.8026 10.79H36.0326C36.0526 11.0233 36.1092 11.2267 36.2026 11.4C36.2959 11.5733 36.4092 11.7167 36.5426 11.83C36.6826 11.9433 36.8359 12.0267 37.0026 12.08C37.1692 12.1333 37.3326 12.16 37.4926 12.16C37.8126 12.16 38.0759 12.0833 38.2826 11.93C38.4892 11.7767 38.6592 11.5867 38.7926 11.36L39.7426 11.83ZM38.7126 9.94C38.6992 9.84 38.6659 9.73 38.6126 9.61C38.5659 9.48333 38.4892 9.37 38.3826 9.27C38.2826 9.16333 38.1492 9.07333 37.9826 9C37.8226 8.92667 37.6259 8.89 37.3926 8.89C37.0726 8.89 36.7959 8.98667 36.5626 9.18C36.3359 9.36667 36.1826 9.62 36.1026 9.94H38.7126ZM44.4204 12.37H44.3604C44.2271 12.5833 44.0237 12.77 43.7504 12.93C43.4771 13.0833 43.1504 13.16 42.7704 13.16C42.4571 13.16 42.1571 13.0967 41.8704 12.97C41.5904 12.8367 41.3437 12.6533 41.1304 12.42C40.9171 12.1867 40.7471 11.9133 40.6204 11.6C40.4937 11.28 40.4304 10.93 40.4304 10.55C40.4304 10.17 40.4937 9.82333 40.6204 9.51C40.7471 9.19 40.9171 8.91333 41.1304 8.68C41.3437 8.44667 41.5904 8.26667 41.8704 8.14C42.1571 8.00667 42.4571 7.94 42.7704 7.94C43.1504 7.94 43.4771 8.02 43.7504 8.18C44.0237 8.33333 44.2271 8.51667 44.3604 8.73H44.4204L44.3604 8.05V5.84H45.4704V13H44.4204V12.37ZM42.9804 12.13C43.1671 12.13 43.3471 12.0933 43.5204 12.02C43.7004 11.9467 43.8537 11.8433 43.9804 11.71C44.1137 11.5767 44.2204 11.4133 44.3004 11.22C44.3804 11.02 44.4204 10.7967 44.4204 10.55C44.4204 10.3033 44.3804 10.0833 44.3004 9.89C44.2204 9.69 44.1137 9.52333 43.9804 9.39C43.8537 9.25667 43.7004 9.15333 43.5204 9.08C43.3471 9.00667 43.1671 8.97 42.9804 8.97C42.7871 8.97 42.6037 9.00667 42.4304 9.08C42.2571 9.15333 42.1037 9.26 41.9704 9.4C41.8437 9.53333 41.7404 9.69667 41.6604 9.89C41.5804 10.0833 41.5404 10.3033 41.5404 10.55C41.5404 10.7967 41.5804 11.0167 41.6604 11.21C41.7404 11.4033 41.8437 11.57 41.9704 11.71C42.1037 11.8433 42.2571 11.9467 42.4304 12.02C42.6037 12.0933 42.7871 12.13 42.9804 12.13Z"
        fill="#044123"
      />
    </svg>
  );
}

export function Trending() {
  return (
    <svg
      width="52"
      height="20"
      viewBox="0 0 52 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="52" height="20" rx="10" fill="#D7F8FA" />
      <path
        d="M8.24 13V6.92H6.24V5.84H11.37V6.92H9.37V13H8.24ZM11.5698 8.1H12.6198V8.84H12.6798C12.7398 8.71333 12.8198 8.59667 12.9198 8.49C13.0264 8.37667 13.1431 8.28333 13.2698 8.21C13.4031 8.13 13.5398 8.07 13.6798 8.03C13.8264 7.98333 13.9664 7.96 14.0998 7.96C14.2598 7.96 14.3964 7.97333 14.5098 8C14.6231 8.02667 14.7264 8.06333 14.8198 8.11L14.4998 9.14C14.4264 9.10667 14.3431 9.08333 14.2498 9.07C14.1631 9.05 14.0564 9.04 13.9298 9.04C13.7498 9.04 13.5831 9.07667 13.4298 9.15C13.2831 9.22333 13.1531 9.32333 13.0398 9.45C12.9264 9.57667 12.8364 9.72667 12.7698 9.9C12.7098 10.0733 12.6798 10.2567 12.6798 10.45V13H11.5698V8.1ZM19.6547 11.83C19.448 12.21 19.1547 12.5267 18.7747 12.78C18.3947 13.0333 17.928 13.16 17.3747 13.16C17.008 13.16 16.668 13.0967 16.3547 12.97C16.048 12.8367 15.7814 12.6533 15.5547 12.42C15.328 12.1867 15.1514 11.9133 15.0247 11.6C14.898 11.28 14.8347 10.93 14.8347 10.55C14.8347 10.1967 14.8947 9.86333 15.0147 9.55C15.1347 9.23 15.3014 8.95333 15.5147 8.72C15.7347 8.48 15.998 8.29 16.3047 8.15C16.6114 8.01 16.9514 7.94 17.3247 7.94C17.7047 7.94 18.0414 8.00333 18.3347 8.13C18.6347 8.25667 18.888 8.43333 19.0947 8.66C19.3014 8.88667 19.458 9.16 19.5647 9.48C19.678 9.8 19.7347 10.15 19.7347 10.53C19.7347 10.5633 19.7347 10.5933 19.7347 10.62C19.728 10.6533 19.7247 10.6833 19.7247 10.71C19.718 10.7367 19.7147 10.7633 19.7147 10.79H15.9447C15.9647 11.0233 16.0214 11.2267 16.1147 11.4C16.208 11.5733 16.3214 11.7167 16.4547 11.83C16.5947 11.9433 16.748 12.0267 16.9147 12.08C17.0814 12.1333 17.2447 12.16 17.4047 12.16C17.7247 12.16 17.988 12.0833 18.1947 11.93C18.4014 11.7767 18.5714 11.5867 18.7047 11.36L19.6547 11.83ZM18.6247 9.94C18.6114 9.84 18.578 9.73 18.5247 9.61C18.478 9.48333 18.4014 9.37 18.2947 9.27C18.1947 9.16333 18.0614 9.07333 17.8947 9C17.7347 8.92667 17.538 8.89 17.3047 8.89C16.9847 8.89 16.708 8.98667 16.4747 9.18C16.248 9.36667 16.0947 9.62 16.0147 9.94H18.6247ZM21.6237 8.76H21.6837C21.8303 8.52667 22.037 8.33333 22.3037 8.18C22.577 8.02 22.8837 7.94 23.2237 7.94C23.8437 7.94 24.307 8.12667 24.6137 8.5C24.9203 8.86667 25.0737 9.35667 25.0737 9.97V13H23.9637V10.12C23.9637 9.69333 23.8637 9.39667 23.6637 9.23C23.4703 9.05667 23.2137 8.97 22.8937 8.97C22.7003 8.97 22.5303 9.01 22.3837 9.09C22.237 9.17 22.1103 9.28 22.0037 9.42C21.897 9.55333 21.817 9.71 21.7637 9.89C21.7103 10.0633 21.6837 10.2467 21.6837 10.44V13H20.5737V8.1H21.6237V8.76ZM29.8598 12.37H29.7998C29.6665 12.5833 29.4632 12.77 29.1898 12.93C28.9165 13.0833 28.5898 13.16 28.2098 13.16C27.8965 13.16 27.5965 13.0967 27.3098 12.97C27.0298 12.8367 26.7832 12.6533 26.5698 12.42C26.3565 12.1867 26.1865 11.9133 26.0598 11.6C25.9332 11.28 25.8698 10.93 25.8698 10.55C25.8698 10.17 25.9332 9.82333 26.0598 9.51C26.1865 9.19 26.3565 8.91333 26.5698 8.68C26.7832 8.44667 27.0298 8.26667 27.3098 8.14C27.5965 8.00667 27.8965 7.94 28.2098 7.94C28.5898 7.94 28.9165 8.02 29.1898 8.18C29.4632 8.33333 29.6665 8.51667 29.7998 8.73H29.8598L29.7998 8.05V5.84H30.9098V13H29.8598V12.37ZM28.4198 12.13C28.6065 12.13 28.7865 12.0933 28.9598 12.02C29.1398 11.9467 29.2932 11.8433 29.4198 11.71C29.5532 11.5767 29.6598 11.4133 29.7398 11.22C29.8198 11.02 29.8598 10.7967 29.8598 10.55C29.8598 10.3033 29.8198 10.0833 29.7398 9.89C29.6598 9.69 29.5532 9.52333 29.4198 9.39C29.2932 9.25667 29.1398 9.15333 28.9598 9.08C28.7865 9.00667 28.6065 8.97 28.4198 8.97C28.2265 8.97 28.0432 9.00667 27.8698 9.08C27.6965 9.15333 27.5432 9.26 27.4098 9.4C27.2832 9.53333 27.1798 9.69667 27.0998 9.89C27.0198 10.0833 26.9798 10.3033 26.9798 10.55C26.9798 10.7967 27.0198 11.0167 27.0998 11.21C27.1798 11.4033 27.2832 11.57 27.4098 11.71C27.5432 11.8433 27.6965 11.9467 27.8698 12.02C28.0432 12.0933 28.2265 12.13 28.4198 12.13ZM32.6688 7.23C32.4554 7.23 32.2754 7.15667 32.1287 7.01C31.9888 6.86333 31.9188 6.68667 31.9188 6.48C31.9188 6.27333 31.9888 6.09667 32.1287 5.95C32.2754 5.80333 32.4554 5.73 32.6688 5.73C32.8754 5.73 33.0488 5.80333 33.1888 5.95C33.3354 6.09667 33.4088 6.27333 33.4088 6.48C33.4088 6.68667 33.3354 6.86333 33.1888 7.01C33.0488 7.15667 32.8754 7.23 32.6688 7.23ZM32.1088 13V8.1H33.2188V13H32.1088ZM35.4713 8.76H35.5313C35.678 8.52667 35.8847 8.33333 36.1513 8.18C36.4247 8.02 36.7313 7.94 37.0713 7.94C37.6913 7.94 38.1547 8.12667 38.4613 8.5C38.768 8.86667 38.9213 9.35667 38.9213 9.97V13H37.8113V10.12C37.8113 9.69333 37.7113 9.39667 37.5113 9.23C37.318 9.05667 37.0613 8.97 36.7413 8.97C36.548 8.97 36.378 9.01 36.2313 9.09C36.0847 9.17 35.958 9.28 35.8513 9.42C35.7447 9.55333 35.6647 9.71 35.6113 9.89C35.558 10.0633 35.5313 10.2467 35.5313 10.44V13H34.4213V8.1H35.4713V8.76ZM42.1687 15.32C41.8287 15.32 41.5253 15.2733 41.2587 15.18C40.9987 15.0933 40.772 14.98 40.5787 14.84C40.3853 14.7 40.2253 14.5433 40.0987 14.37C39.9787 14.1967 39.8887 14.03 39.8287 13.87L40.8887 13.44C40.982 13.7 41.142 13.91 41.3687 14.07C41.5953 14.2367 41.862 14.32 42.1687 14.32C42.6287 14.32 42.9853 14.18 43.2387 13.9C43.4987 13.62 43.6287 13.2333 43.6287 12.74V12.34H43.5687C43.4153 12.56 43.202 12.7433 42.9287 12.89C42.662 13.0367 42.3487 13.11 41.9887 13.11C41.6887 13.11 41.3987 13.0467 41.1187 12.92C40.8387 12.7933 40.5887 12.6167 40.3687 12.39C40.1553 12.1633 39.9853 11.89 39.8587 11.57C39.732 11.25 39.6687 10.9 39.6687 10.52C39.6687 10.14 39.732 9.79333 39.8587 9.48C39.9853 9.16 40.1553 8.88667 40.3687 8.66C40.5887 8.43333 40.8387 8.25667 41.1187 8.13C41.3987 8.00333 41.6887 7.94 41.9887 7.94C42.3487 7.94 42.662 8.01333 42.9287 8.16C43.202 8.30667 43.4153 8.49 43.5687 8.71H43.6287V8.1H44.6987V12.72C44.6987 13.14 44.632 13.51 44.4987 13.83C44.372 14.1567 44.1953 14.43 43.9687 14.65C43.7487 14.87 43.482 15.0367 43.1687 15.15C42.862 15.2633 42.5287 15.32 42.1687 15.32ZM42.2087 12.08C42.3887 12.08 42.5653 12.0467 42.7387 11.98C42.912 11.9133 43.062 11.8133 43.1887 11.68C43.322 11.5467 43.4287 11.3833 43.5087 11.19C43.5887 10.9967 43.6287 10.7733 43.6287 10.52C43.6287 10.2733 43.5887 10.0533 43.5087 9.86C43.4287 9.66 43.322 9.49667 43.1887 9.37C43.062 9.23667 42.912 9.13667 42.7387 9.07C42.5653 8.99667 42.3887 8.96 42.2087 8.96C42.022 8.96 41.842 8.99667 41.6687 9.07C41.502 9.13667 41.352 9.23667 41.2187 9.37C41.0853 9.50333 40.9787 9.66667 40.8987 9.86C40.8187 10.0533 40.7787 10.2733 40.7787 10.52C40.7787 10.7667 40.8187 10.9867 40.8987 11.18C40.9787 11.3733 41.0853 11.5367 41.2187 11.67C41.352 11.8033 41.502 11.9067 41.6687 11.98C41.842 12.0467 42.022 12.08 42.2087 12.08Z"
        fill="#069E9E"
      />
    </svg>
  );
}

export function OfferLetterIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.31172 13.5H17.8117C18.2095 13.5 18.5911 13.342 18.8724 13.0607C19.1537 12.7794 19.3117 12.3978 19.3117 12C19.3117 11.6022 19.1537 11.2206 18.8724 10.9393C18.5911 10.658 18.2095 10.5 17.8117 10.5H4.31172C2.69922 10.5 1.38672 11.8406 1.38672 13.5C1.38672 15.1594 2.69922 16.5 4.31172 16.5H17.9992C19.1927 16.5 20.3373 16.0259 21.1812 15.182C22.0251 14.3381 22.4992 13.1935 22.4992 12C22.4992 10.8065 22.0251 9.66193 21.1812 8.81802C20.3373 7.97411 19.1927 7.5 17.9992 7.5H7.49922"
        stroke="#2F7BF5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RightMarkIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 6.75L9.75 17.25L4.5 12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function LinkSimpleIcon({ color }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.62048 11.3836L11.3877 6.60938"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1953 12.5789L8.20543 14.5688C7.89195 14.8822 7.51979 15.1309 7.11021 15.3006C6.70063 15.4702 6.26164 15.5575 5.81832 15.5575C4.92298 15.5575 4.06431 15.2019 3.43121 14.5688C2.79811 13.9356 2.44243 13.077 2.44243 12.1816C2.44243 11.2863 2.79811 10.4276 3.43121 9.79453L5.42105 7.80469"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5789 10.1845L14.5688 8.19463C15.2019 7.56153 15.5575 6.70286 15.5575 5.80752C15.5575 4.91218 15.2019 4.05351 14.5688 3.42041C13.9356 2.78731 13.077 2.43164 12.1816 2.43164C11.2863 2.43164 10.4276 2.78731 9.79453 3.42041L7.80469 5.41026"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EyeIcon({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 6.125C5.25 6.125 1.75 14 1.75 14C1.75 14 5.25 21.875 14 21.875C22.75 21.875 26.25 14 26.25 14C26.25 14 22.75 6.125 14 6.125Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 18.375C16.4162 18.375 18.375 16.4162 18.375 14C18.375 11.5838 16.4162 9.625 14 9.625C11.5838 9.625 9.625 11.5838 9.625 14C9.625 16.4162 11.5838 18.375 14 18.375Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LinkBreak({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6.75V4.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 19.5V17.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 9H4.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 15H17.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.65638 12.0391L5.59701 13.0984C4.89335 13.8021 4.49805 14.7564 4.49805 15.7516C4.49805 16.2443 4.5951 16.7322 4.78366 17.1874C4.97222 17.6426 5.24859 18.0563 5.59701 18.4047C5.94542 18.7531 6.35905 19.0295 6.81427 19.218C7.2695 19.4066 7.7574 19.5036 8.25013 19.5036C9.24525 19.5036 10.1996 19.1083 10.9033 18.4047L11.9626 17.3453"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3434 11.9626L18.4027 10.9033C19.1064 10.1996 19.5017 9.24525 19.5017 8.25013C19.5017 7.25502 19.1064 6.30066 18.4027 5.59701C17.6991 4.89335 16.7447 4.49805 15.7496 4.49805C14.7545 4.49805 13.8001 4.89335 13.0965 5.59701L12.0371 6.65638"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}


export function PushNIcon({ color }) {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 10C18 8.4087 17.3679 6.88258 16.2426 5.75736C15.1174 4.63214 13.5913 4 12 4C10.4087 4 8.88258 4.63214 7.75736 5.75736C6.63214 6.88258 6 8.4087 6 10C6 17 3 19 3 19H21C21 19 18 17 18 10Z"
        stroke={ color }
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.73 23C13.5542 23.3031 13.3019 23.5547 12.9982 23.7295C12.6946 23.9044 12.3504 23.9965 12 23.9965C11.6496 23.9965 11.3054 23.9044 11.0018 23.7295C10.6982 23.5547 10.4458 23.3031 10.27 23"
        stroke={ color }
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="18" cy="6" r="6" fill="#F83A3A" />
      <path
        d="M17.672 9V4.76L16.704 5.168L16.32 4.28L17.928 3.528H18.72V9H17.672Z"
        fill="white"
      />
    </svg>
  );
}
